export default {
  "de": {
    "attendance.coachFallback": "Trainer #{{id}}",
    "attendance.partialDetailsHint": "Einige Anwesenheitsdetails konnten nicht vollständig geladen werden. Die Liste ist möglicherweise unvollständig. Aktualisieren Sie sie, um es erneut zu versuchen.",
    "attendance.sessionDetailsLoadFailed": "Sitzungsdetails konnten nicht geladen werden. Die Teilnehmerliste funktioniert ggf. trotzdem; aktualisieren zum erneuten Versuch.",
    "attendance.studentFallback": "Schüler #{{id}}",
    "attendance.verifyAttendanceFailed": "Anwesenheit konnte nicht geprüft werden. Abschließen ist blockiert, bis dies gelingt — aktualisieren und erneut versuchen.",
    "attendance.walkInsLoadFailed": "Walk-in-Schüler konnten nicht geladen werden. Aktualisieren und erneut versuchen.",
    "auth.accountDisabled": "Dieses Konto wurde deaktiviert.",
    "auth.checkingSetup": "Akademie-Setup wird überprüft…",
    "calendar.holidaysLoadFailed": "Feiertage konnten nicht geladen werden. Der Kalender kann wie eine normale Arbeitswoche aussehen.",
    "calendar.viewingOtherCoachNoHost": "Anderer Trainer wird angezeigt — öffnen Sie Ihren Kalender, um zu hosten.",
    "charts.academyByBranch": "Brutto nach Filiale",
    "charts.academyByBranchHint": "Bruttoumsatz der Filialen vergleichen",
    "charts.academyMonthlyTrend": "Monatlicher Umsatztrend",
    "charts.academyMonthlyTrendHint": "Brutto-, Akademie- und Trainerauszahlungen nach Monat",
    "charts.academyRevenueSplit": "Umsatzaufteilung",
    "charts.academyRevenueSplitHint": "Akademie- vs. Trainerauszahlung",
    "charts.atRisk": "Gefährdet",
    "charts.atRiskCount": "{{count}} Studenten",
    "charts.atRiskRateHint": "Niedrigste Quoten in der aktuellen Liste",
    "charts.atRiskShare": "Gefährdete Aktie",
    "charts.atRiskShareHint": "Prozentsatz des Dienstplans, der Aufmerksamkeit benötigt",
    "charts.atRiskTiers": "Risikostufen",
    "charts.attendanceBuckets": "Verteilung der Anwesenheitsquote",
    "charts.attendanceBucketsHint": "Schüler nach Anwesenheitsquote",
    "charts.attendanceRates": "Anwesenheitsquoten",
    "charts.attendanceSnapshot": "Anwesenheitsübersicht",
    "charts.attendanceWtd": "Anwesenheit diese Woche",
    "charts.childAttendance": "Anwesenheit des Kindes",
    "charts.childRating": "Kinderbewertung",
    "charts.coachGrossCompare": "Brutto nach Trainer",
    "charts.coachGrossCompareHint": "Bruttoumsatz der Trainer vergleichen",
    "charts.coachRevenueTrend": "Umsatz pro Tag",
    "charts.coachRevenueTrendHint": "Brutto-, Akademie- und Trainereinnahmen im Berichtszeitraum",
    "charts.commissionSplit": "Provisionsaufteilung",
    "charts.commissionSplitHint": "Akademie- vs. Traineranteil",
    "charts.completedSessionsWeek": "Aus den abgeschlossenen Sitzungen dieser Woche",
    "charts.defaultSeries": "Wert",
    "charts.gameRecord": "Spielrekord",
    "charts.healthy": "Gesund",
    "charts.hoursByWeekday": "Stunden pro Wochentag",
    "charts.legend": "Diagrammlegende",
    "charts.manageBranches": "Filialen",
    "charts.managerBranchHint": "Aktive Studierende in Ihren Filialen",
    "charts.noAtRiskData": "Es liegen noch keine Risikodaten zum Diagramm vor",
    "charts.noAttendanceBucketData": "Keine Schülerzeilen zum Anzeigen",
    "charts.noAttendanceMarks": "Diese Woche gibt es noch keine Anwesenheitsnoten",
    "charts.noAttendanceYet": "Diese Woche sind noch keine Sitzungen abgeschlossen",
    "charts.noBranchAmountData": "Keine Filialbeträge zum Anzeigen",
    "charts.noBranchData": "Noch keine Filialanmeldungsdaten",
    "charts.noBranchEnrollmentYet": "Studierende sind sichtbar, aber in Ihren Zweigstellen sind noch keine eingeschrieben",
    "charts.noCoachData": "Keine Traineraufschlüsselung zum Anzeigen",
    "charts.noDataYet": "Noch keine Daten zum Diagramm",
    "charts.noGamesYet": "Noch keine bewerteten Spiele",
    "charts.noHealthData": "Noch keine Gesundheitsdaten für Studierende",
    "charts.noHoursYet": "Diese Woche wurden keine Unterrichtsstunden erfasst",
    "charts.noMonthlyData": "Keine monatliche Aufschlüsselung zum Anzeigen",
    "charts.noPlayingYet": "Noch keine Spielaktivität",
    "charts.noRecentMarks": "Keine aktuellen Anwesenheitsnoten",
    "charts.noSlotData": "Keine Anwesenheitsslots zum Anzeigen",
    "charts.noSplitData": "Keine Provisionsaufteilung zum Anzeigen",
    "charts.noStatementStatusData": "Kein Anweisungsstatus zum Diagramm vorhanden",
    "charts.noStatusData": "Keine Statusgruppen zum Anzeigen",
    "charts.noStudentsInYourBranches": "In Ihren Filialen sind noch keine Studierenden eingeschrieben",
    "charts.noTrendData": "Kein Tagesumsatz zum Anzeigen",
    "charts.notEnrolled": "Nicht eingeschrieben",
    "charts.open": "Offen",
    "charts.paymentsDueByBranch": "Offener Betrag nach Filiale",
    "charts.paymentsDueByBranchHint": "Überfällige Beträge nach Filiale",
    "charts.paymentsDueStatus": "Zahlungsstatus-Mix",
    "charts.paymentsDueStatusHint": "Überfällig, niedriges Guthaben und OK-Schüler",
    "charts.playingPeek": "Spielaktivität",
    "charts.presentVsAbsent": "Vorhanden vs. abwesend",
    "charts.presentVsAbsentHint": "Gesamtzahl der Anwesenheitsslots im Zeitraum",
    "charts.rate": "Rate",
    "charts.recentMarks": "Aktuelle Noten",
    "charts.statementStatusMix": "Status der Kontoauszugs-E-Mails",
    "charts.statementStatusMixHint": "Gesendet, ausstehend, fehlgeschlagen und nicht gesendet",
    "charts.studentHealth": "Schülerstatus",
    "charts.studentHealthHint": "Gefährdeter vs. gesunder Kader",
    "charts.students": "Schüler",
    "charts.studentsByBranch": "Schüler nach Filiale",
    "charts.studentsByBranchHint": "Eingeschriebene Schüler pro Filiale (einschließlich nicht eingeschriebener)",
    "charts.tierCriticalShort": "Kritisch",
    "charts.tierHighShort": "Hoch",
    "charts.tierMediumShort": "Mittel",
    "charts.unsolvedAttempts": "Andere Versuche",
    "charts.viewAtRisk": "Ansicht gefährdet",
    "charts.viewHistory": "Geschichte",
    "charts.viewStudents": "Studenten",
    "charts.weekToDate": "Bisherige Woche",
    "classroom.live.notStartedHint": "Ihr Trainer hat diesen Online-Kurs noch nicht gestartet.",
    "classroom.live.notStartedYet": "Noch nicht begonnen",
    "classroom.meeting.admitAll": "Gib alles zu",
    "classroom.meeting.admitFailed": "Wartende Studenten konnten nicht zugelassen werden.",
    "classroom.meeting.admitOne": "Zugeben",
    "classroom.meeting.admitting": "Zugeben…",
    "classroom.meeting.connectedHint": "Live über ChessDesk",
    "classroom.meeting.embedAuthMissing": "Meeting-Zugangsdaten nicht verfügbar. Prüfen Sie die Zoom Meeting SDK-Zugangsdaten unter Klassenraum → Zoom.",
    "classroom.meeting.embedUnavailableRetry": "Video konnte im Browser nicht gestartet werden. Erneut versuchen oder „In Zoom-App öffnen“ nutzen.",
    "classroom.meeting.guest": "Gast",
    "classroom.meeting.hostZakMissing": "Host-Zugangsdaten fehlen. Setzen Sie unter Klassenraum → Einstellungen die Zoom-Host-E-Mail auf einen lizenzierten Zoom-Benutzer und versuchen Sie es erneut.",
    "classroom.meeting.notActuallyHost": "Beigetreten, aber Zoom hat keine Host-Rechte erteilt. Setzen Sie unter Klassenraum → Einstellungen die Zoom-Host-E-Mail auf Ihren lizenzierten Zoom-Login, verlassen Sie das Meeting und treten Sie erneut als Trainer bei.",
    "classroom.meeting.scriptLoadFailed": "Zoom-Skript konnte nicht geladen werden: {{src}}",
    "classroom.meeting.sdkLoadFailed": "Zoom Meeting SDK konnte nicht geladen werden.",
    "classroom.meeting.waitingForHost": "Warten Sie, bis Ihr Trainer den Unterricht startet. Bleiben Sie auf dieser Seite — Sie treten bei, sobald er beitritt.",
    "classroom.meeting.waitingGuest": "Gast",
    "classroom.meeting.waitingRoomTitle": "{{count}} Schüler im Wartezimmer",
    "classroom.meeting.zoomJoinFailed": "Zoom-Beitritt fehlgeschlagen",
    "classroom.zoom.clientIdPlaceholder": "z.B. AbCdEfGh...",
    "classroom.zoom.meetingSdkHeading": "Eingebettetes Video (Meeting SDK)",
    "common.academyLogo": "Logo der Akademie",
    "common.backHome": "Zurück nach Hause",
    "common.currencyWord": "Währung",
    "common.guest": "Gast",
    "common.listLoadFailed": "Liste konnte nicht geladen werden. Aktualisieren und erneut versuchen.",
    "common.noData": "Keine Benutzer gefunden.",
    "common.notSet": "nicht gesetzt",
    "common.optional": "Optional",
    "common.optionsLoadFailed": "Optionen konnten nicht geladen werden. Seite aktualisieren oder erneut versuchen.",
    "common.pageNotFound": "Seite nicht gefunden",
    "common.pageNotFoundHint": "Dieser Link stimmt mit keiner Seite in der App überein. Überprüfen Sie die URL oder gehen Sie zurück nach Hause.",
    "common.period": "Zeitraum",
    "common.required": "Erforderlich",
    "common.retry": "Erneut versuchen",
    "common.rowN": "Zeile {{n}}",
    "common.unknownError": "Unbekannter Fehler",
    "enrollments.form.noStudentMatches": "Keine Schüler entsprechen Ihrer Suche.",
    "enrollments.form.noStudentsAvailable": "Keine Schüler zum Einschreiben verfügbar.",
    "enrollments.paymentModal.coachAskTopUp": "Bitten Sie einen Manager oder Admin, das Wallet dieses Schülers aufzuladen, und aktualisieren Sie dann den Kontostand.",
    "exports.batchId": "Gruppen-ID",
    "exports.batchName": "Gruppenname",
    "exports.branch": "Filiale",
    "exports.branchId": "Filial-ID",
    "exports.code": "Code",
    "exports.email": "E-Mail",
    "exports.id": "ID",
    "exports.level": "Ebene",
    "exports.levelId": "Stufen-ID",
    "exports.manager": "Manager",
    "exports.mode": "Modus",
    "exports.name": "Name",
    "exports.phone": "Telefon",
    "exports.roles": "Rollen",
    "exports.scope": "Umfang",
    "exports.scopeBatch": "Gruppe #{{id}}",
    "exports.scopeBranch": "Filiale #{{id}}",
    "exports.scopeGlobal": "Global",
    "exports.scopeLevel": "Stufe #{{id}}",
    "exports.sessionDays": "Sitzungstage",
    "exports.sheetGeneric": "Tabelle",
    "exports.sheetReport": "Bericht",
    "exports.status": "Status",
    "exports.userId": "Benutzer-ID",
    "exports.username": "Benutzername",
    "exports.value": "Wert",
    "forms.address.citiesLoadFailed": "Städte konnten nicht geladen werden — Sie können den Stadtnamen trotzdem eingeben.",
    "forms.batch.loadFailed": "Dieser Stapel konnte nicht geladen werden.",
    "forms.branch.loadFailed": "Diese Filiale konnte nicht geladen werden.",
    "forms.common.back": "Zurück",
    "forms.level.loadFailed": "Dieses Level konnte nicht geladen werden.",
    "forms.student.eloPlaceholder": "z.B. 1650",
    "forms.student.fideIdPlaceholder": "z. B. 1503014",
    "forms.student.fideTitlePlaceholder": "z.B. CM, FM, IM, GM",
    "levels.unnamed": "Stufe",
    "notificationBell.countUnknown": "Anzahl ungelesen nicht verfügbar",
    "notificationBell.markReadFailed": "Als gelesen markieren fehlgeschlagen. Erneut versuchen.",
    "notifications.content.reviewGame": "Rezensionsspiel",
    "notificationsPage.markAllFailed": "Alle als gelesen markieren fehlgeschlagen. Erneut versuchen.",
    "pages.adminDashboard.statsLoadFailed": "Dashboard-Statistiken konnten nicht geladen werden. Die folgenden Abbildungen sind möglicherweise unvollständig. Aktualisieren Sie sie, um es erneut zu versuchen.",
    "pages.coaches.manageAssignments.coachLabel": "Trainer: {{name}}",
    "pages.discountForm.codePlaceholder": "z. B. SIBLING_10, EARLY_BIRD",
    "pages.discountForm.flatValuePlaceholder": "z. B. 500",
    "pages.discountForm.namePlaceholder": "z. B. Geschwisterrabatt, Frühbucherrabatt",
    "pages.discountForm.percentValuePlaceholder": "z. B. 10",
    "pages.enrollmentDetail.afterDiscountApplied": "Nach {{value}} Rabatt",
    "pages.enrollmentDetail.batchLoadFailed": "Batch-Details konnten nicht geladen werden. Gebühren- und Periodenangaben können unvollständig sein.",
    "pages.enrollmentDetail.receivers.OTHERS": "Andere",
    "pages.enrollmentDetail.receivers.USER": "Schüler / Familie",
    "pages.enrollmentDetail.types.REGULAR": "Regulär",
    "pages.enrollmentDetail.types.SINGLE_SESSION": "Einzelstunde",
    "pages.feePlanForm.groupTypes.GROUP": "Gruppe",
    "pages.feePlanForm.groupTypes.ONE_TO_ONE": "Einzel",
    "pages.feePlanForm.planTypes.MONTHLY": "Monatlich",
    "pages.feePlanForm.planTypes.PACKAGE": "Paket",
    "pages.feePlanForm.planTypes.PER_SESSION": "Pro Stunde",
    "pages.managerDashboard.statsLoadFailed": "Dashboard-Statistiken konnten nicht geladen werden. Die folgenden Abbildungen sind möglicherweise unvollständig. Aktualisieren Sie sie, um es erneut zu versuchen.",
    "pages.notifications.classroomStarted": "Benachrichtigungen bei Start des Live-Unterrichts",
    "pages.parentHome.childPlayingLive": "Spielt jetzt live",
    "pages.parentHome.noPlayingYet": "Für dieses Kind wurden noch keine Plattformspiele gespielt.",
    "pages.parentHome.partialSnapshot": "Einige Kind-Übersichtsdaten konnten nicht geladen werden. Zahlen können unvollständig sein — aktualisieren und erneut versuchen.",
    "pages.parentHome.playingLoadFailed": "Die Aktivität der Spielplattform konnte nicht geladen werden.",
    "pages.parentHome.playingPlatform": "Spielplattform",
    "pages.parentHome.snapshotLoadFailed": "Kind-Übersicht konnte nicht geladen werden. Aktualisieren und erneut versuchen.",
    "pages.parentHome.viewPlayProfile": "Spielprofil ansehen",
    "pages.parentHome.watchLive": "Live ansehen",
    "pages.sessionStatement.transactionsCount": "{{count}} Transaktionen",
    "pages.studentBulkImport.cols.addressLine1": "Straße, Wohnungs-/Hausnummer",
    "pages.studentBulkImport.cols.addressLine2": "Zusätzliche Adressinformationen – Wahrzeichen, Gebiet usw.",
    "pages.studentBulkImport.cols.city": "Stadt",
    "pages.studentBulkImport.cols.country": "Land",
    "pages.studentBulkImport.cols.dob": "Geburtsdatum im regionalen Format der Akademie ({{format}}) oder JJJJ-MM-TT",
    "pages.studentBulkImport.cols.email": "Gültige E-Mail-Adresse – muss eindeutig sein",
    "pages.studentBulkImport.cols.firstName": "Unicode-Buchstaben erlaubt (z. B. François, Müller)",
    "pages.studentBulkImport.cols.gender": "MÄNNLICH | WEIBLICH | ANDERE (Großbuchstaben)",
    "pages.studentBulkImport.cols.lastName": "Unicode-Buchstaben erlaubt (z. B. Dupont, van der Berg)",
    "pages.studentBulkImport.cols.middleName": "Optional – Akzente, Leerzeichen, Bindestriche, Apostrophe OK",
    "pages.studentBulkImport.cols.password": "Optional – überschreibt das Standardkennwort für diese Zeile",
    "pages.studentBulkImport.cols.phoneNumber": "Lokale Nummer oder vollständige internationale Nummer (+…). Lokale Nummern verwenden das Akademieland aus den Regionaleinstellungen.",
    "pages.studentBulkImport.cols.pincode": "PIN / Postleitzahl",
    "pages.studentBulkImport.cols.state": "Staat/Provinz",
    "pages.studentBulkImport.cols.username": "Eindeutiger Login-Benutzername (z. B. rahul.sharma)",
    "pages.studentBulkImport.csvGuide": "CSV-Formatleitfaden",
    "pages.studentBulkImport.duplicateSkipped": "Übersprungen — Schüler mit diesem Benutzernamen oder dieser E-Mail existiert bereits",
    "pages.studentBulkImport.processingRow": "Zeile {{current}} von {{total}} — {{name}}",
    "pages.studentBulkImport.unknownError": "Unbekannter Fehler",
    "pages.studentBulkImport.validation.dobFormat": "dob muss {{format}} oder JJJJ-MM-TT sein",
    "pages.studentBulkImport.validation.dobInvalid": "Geburtsdatum ist kein gültiges Datum",
    "pages.studentBulkImport.validation.emailInvalid": "E-Mail „{{value}}“ ist ungültig",
    "pages.studentBulkImport.validation.genderInvalid": "Geschlecht „{{value}}“ ist ungültig – muss MÄNNLICH, FEMALE oder ANDERE sein",
    "pages.studentBulkImport.validation.genderRequired": "Geschlecht ist erforderlich (MÄNNLICH / WEIBLICH / ANDERE)",
    "pages.studentBulkImport.validation.invalidName": "{{field}} muss ein gültiger Name sein (Buchstaben, Leerzeichen, Bindestriche, Apostrophe; Akzente erlaubt)",
    "pages.studentBulkImport.validation.phoneInvalid": "phoneNumber ist ungültig",
    "pages.studentBulkImport.validation.required": "{{field}} ist erforderlich",
    "pages.studentDashboard.partialLoad": "Einige Dashboard-Daten konnten nicht geladen werden. Die Zahlen sind möglicherweise unvollständig. Aktualisieren Sie sie, um es erneut zu versuchen.",
    "pages.userDetails.genderFemale": "Weiblich",
    "pages.userDetails.genderMale": "Männlich",
    "pages.userDetails.genderOther": "Divers",
    "pages.wallet.gatewaysLoadFailed": "Online-Zahlungsoptionen konnten nicht geprüft werden. Aktualisieren und erneut versuchen.",
    "pages.wallet.methodCash": "Bar",
    "pages.wallet.methodsLoadFailed": "Zahlungsmethoden konnten nicht geladen werden. Die Modusliste ist möglicherweise unvollständig.",
    "pages.wallet.unsupportedGateway": "Nicht unterstützte Antwort der Zahlungs-Gateway.",
    "pages.walletTopup.noManagedStudents": "Noch keine Schüler in Ihren verwalteten Filialen. Bitte zuerst Schüler hinzufügen oder einschreiben.",
    "pages.walletTopup.staffLoadFailed": "Mitarbeiterliste konnte nicht geladen werden. Aktualisieren und erneut versuchen.",
    "pages.walletTopup.studentsLoadFailed": "Schüler konnten nicht geladen werden. Aktualisieren und erneut versuchen.",
    "parent.childrenLoadFailed": "Verknüpfte Schüler konnten nicht geladen werden",
    "parent.childrenLoadFailedHint": "Das ist nicht dasselbe wie keine Kinder zu haben. Aktualisieren Sie, um es erneut zu versuchen.",
    "phone.digitsRequired": "Die Telefonnummer muss Ziffern enthalten.",
    "phone.required": "Telefonnummer ist erforderlich.",
    "playing.academyStudents": "Studenten der Akademie",
    "playing.assignPractice": "Hausaufgaben",
    "playing.assignSelectedPack": "Ausgewählte zuweisen",
    "playing.assignToStudent": "Zuordnen zu",
    "playing.backToHub": "Zurück zum Hub",
    "playing.checkIn": "Einchecken",
    "playing.checkInFailed": "Der Check-in konnte nicht aktualisiert werden.",
    "playing.checkedIn": "In",
    "playing.checkedInCount": "{{checked}}/{{total}} eingecheckt",
    "playing.coachBoardShortcut": "Lehrbrett + Klassenraum",
    "playing.coachDebriefBoards": "Nachbesprechung des Trainers – alle Foren",
    "playing.coachDesk": "Schreibtisch",
    "playing.coachRosterPicker": "Student im Dienstplan",
    "playing.coachRosterPickerMe": "Meine eigenen Spiele",
    "playing.confirmMoveAction": "Spielzug",
    "playing.copyStandings": "Tabellenstand kopieren",
    "playing.copyStudyPgn": "Kommentierte PGN kopieren",
    "playing.copyTeachingLink": "Lehrlink kopieren",
    "playing.createAndOpen": "Erstellen und öffnen",
    "playing.createBan": "Spieler sperren",
    "playing.createDraft": "Entwurf speichern",
    "playing.defaultTeamA": "Mannschaft A",
    "playing.defaultTeamB": "Mannschaft B",
    "playing.dismissPack": "Paket verwerfen",
    "playing.draftFromMistakes": "Draft-Paket aus dem Spiel",
    "playing.draws": "Zieht",
    "playing.fairnessTeachingHint": "{{n}} Züge markiert (höchste Stufe: {{level}}). Zum Unterrichten nutzen — bei Bedarf Fair Play öffnen.",
    "playing.friendlyRematch": "Freundschaftlicher Rückkampf",
    "playing.friendlyRematchHint": "Außerhalb der Veranstaltung · Lässig (unbewertet)",
    "playing.gameType.VS_COMPUTER": "gg. Computer",
    "playing.increment": "Inkrement (Sek.)",
    "playing.liftBan": "Liftverbot",
    "playing.livePeekLoadFailed": "Live-Spiele konnten momentan nicht geladen werden.",
    "playing.loadRecentGame": "Laden Sie ein aktuelles Spiel",
    "playing.loadRecentGamePlaceholder": "Wähle ein fertiges Spiel…",
    "playing.losses": "Verluste",
    "playing.matchmakingPausedShort": "Matchmaking pausiert – Sperrprüfung erneut versuchen",
    "playing.material": "Material",
    "playing.mistakeCount": "{{n}} Fehler",
    "playing.noRecentGamesToLoad": "Es sind noch keine fertigen Spiele zum Laden vorhanden. Fügen Sie ein PGN ein oder legen Sie unten ein FEN fest.",
    "playing.nudgeSent": "Erinnerung gesendet.",
    "playing.openCoachBoard": "Offen an der Bustafel",
    "playing.openFairPlay": "Offene Fairplay-Rezension",
    "playing.openForRegistration": "Zur Registrierung geöffnet",
    "playing.openRegistrationNow": "Jetzt Anmeldung eröffnen (ansonsten als Entwurf speichern)",
    "playing.openings.benoni_benko_path": "Benoni- / Benkö-Pfad",
    "playing.openings.birds_opening": "Bird-Eröffnung",
    "playing.openings.caro_kann_advance": "Caro-Kann — Vorstoß",
    "playing.openings.caro_kann_classical": "Caro-Kann — Klassisch",
    "playing.openings.dutch_defence": "Holländische Verteidigung",
    "playing.openings.english_1_e5": "Englisch — 1…e5",
    "playing.openings.english_1_e6": "Englisch — 1…e6",
    "playing.openings.english_anglo_indian": "Englisch — Anglo-Indisch",
    "playing.openings.english_opening": "Englische Eröffnung",
    "playing.openings.english_symmetrical": "Englisch — Symmetrisch",
    "playing.openings.french_advance": "Französisch — Vorstoß",
    "playing.openings.french_classical": "Französisch — Klassisch",
    "playing.openings.french_exchange": "Französisch — Abtausch",
    "playing.openings.giuoco_piano_open": "Italienisch — Offen",
    "playing.openings.indian_defence": "Indische Verteidigung",
    "playing.openings.kings_indian_defence": "Königsindische Verteidigung",
    "playing.openings.kings_knight_two_knights_path": "Königsspringer — Zweispringer-Pfad",
    "playing.openings.london_system_main_line": "Londoner System — Hauptvariante",
    "playing.openings.nimzo_indian_defence": "Nimzo-Indisch",
    "playing.openings.nimzo_indian_path": "Nimzo-Indisch-Pfad",
    "playing.openings.nimzo_larsen_attack": "Nimzo-Larsen-Angriff",
    "playing.openings.queens_gambit_accepted": "Angenommenes Damengambit",
    "playing.openings.queens_gambit_declined_london_hybrid": "Abgelehntes Damengambit — London-Hybrid",
    "playing.openings.queens_indian_nimzo_path": "Damenindisch / Nimzo-Pfad",
    "playing.openings.r_ti_opening": "Réti-Eröffnung",
    "playing.openings.ruy_lopez_morphy_closed": "Spanisch — Morphy, geschlossen",
    "playing.openings.ruy_lopez_morphy_defence": "Spanisch — Morphy-Verteidigung",
    "playing.openings.scandinavian_2_nf6": "Skandinavisch — 2…Nf6",
    "playing.openings.scandinavian_2_qxd5": "Skandinavisch — 2…Dxd5",
    "playing.openings.sicilian_2_d6": "Sizilianisch — 2…d6",
    "playing.openings.sicilian_2_e6": "Sizilianisch — 2…e6",
    "playing.openings.sicilian_2_nc6": "Sizilianisch — 2…Sc6",
    "playing.openings.sicilian_2_nf3": "Sizilianisch — 2.Sf3",
    "playing.openings.sicilian_classical_path": "Sizilianisch — Klassischer Pfad",
    "playing.openings.sicilian_dragon": "Sizilianisch — Drache",
    "playing.openings.sicilian_dragon_classical": "Sizilianisch — Drache, klassisch",
    "playing.openings.sicilian_dragon_yugoslav": "Sizilianisch — Drache, jugoslawisch",
    "playing.openings.sicilian_hyperaccelerated": "Sizilianisch — Hyperbeschleunigt",
    "playing.openings.sicilian_najdorf": "Sizilianisch — Najdorf",
    "playing.openings.sicilian_najdorf_english_attack": "Sizilianisch — Najdorf, Englischer Angriff",
    "playing.openings.slav_defence": "Slawische Verteidigung",
    "playing.openings.van_geet_opening": "Van-Geet-Eröffnung",
    "playing.packAssignEmpty": "Wählen Sie Rätsel und Schüler aus, die Sie zuweisen möchten.",
    "playing.packAssigned": "{{n}} Hausaufgabenrätsel zugewiesen.",
    "playing.parentChallengeBlockedHint": "Eltern können gegen den Computer spielen und ihre Kinder beobachten – menschliche Herausforderungen sind etwas für Spieler.",
    "playing.parentChallengeBlockedTitle": "Herausforderungen sind für Spieler",
    "playing.parentChallengeHint": "Herausforderungen werden vom Konto Ihres Kindes gesendet, nicht von Ihrem.",
    "playing.parentChallengeToastHint": "Eltern spielen keine menschlichen Spiele – lehnen Sie diese Einladung ab oder spielen Sie vom Hub aus gegen den Computer.",
    "playing.pgn.clubGame": "Vereinspartei",
    "playing.pickTeam": "Wählen Sie ein Team",
    "playing.playersCount": "{{n}} Spieler",
    "playing.privateGame": "Privat",
    "playing.privateLinkHint": "Diese Partie ist privat — der kopierte Link funktioniert nur für die beiden Spieler (und Mitarbeiter).",
    "playing.profile": "Profil",
    "playing.quality.best": "Beste",
    "playing.quality.blunder": "Patzer",
    "playing.quality.brilliant": "Brillant",
    "playing.quality.good": "Gut",
    "playing.quality.inaccuracy": "Ungenauigkeit",
    "playing.quality.mistake": "Fehler",
    "playing.recentGamesLoadFailed": "Die letzten Spiele konnten für die Auswahl nicht geladen werden.",
    "playing.rematchNightHint": "Freundliche (nicht bewertete) Herausforderungen außerhalb der Veranstaltung",
    "playing.rematchNightOpponents": "Rückkampf gegen Nachtgegner",
    "playing.removePlayer": "Entfernen",
    "playing.removePlayerConfirm": "{{name}} von diesem Clubabend entfernen?",
    "playing.removePlayerFailed": "Der Spieler konnte nicht entfernt werden.",
    "playing.reviewReadyStrip": "Rezension bereit",
    "playing.saveDue": "Fälligkeit speichern",
    "playing.saveFailed": "Konnte nicht gespeichert werden.",
    "playing.scrubToMistake": "Schrubben Sie mit einer optimalen Bewegung an einen Fehler heran, um eine Lage einzusparen.",
    "playing.selectStudent": "Schüler auswählen…",
    "playing.solved": "Gelöst",
    "playing.speed.BLITZ": "Blitz",
    "playing.speed.BULLET": "Bullet",
    "playing.speed.CLASSICAL": "Klassisch",
    "playing.speed.CORRESPONDENCE": "Fernschach",
    "playing.speed.RAPID": "Schnellschach",
    "playing.startingNow": "Ab sofort",
    "playing.startsAt": "Beginnt um",
    "playing.startsIn": "Beginnt in {{when}}",
    "playing.stockfish.disabled": "Schach-Engine-Analyse ist auf diesem Server deaktiviert.",
    "playing.stockfish.notStarted": "Die Schach-Engine ist noch nicht bereit.",
    "playing.stockfish.unavailable": "Schach-Engine-Analyse ist derzeit nicht verfügbar.",
    "playing.studyMistakes": "Lernfehler",
    "playing.studyOnCoachBoard": "Studie",
    "playing.studyPgnCopied": "Kommentiertes PGN kopiert",
    "playing.studySource": "Studienquelle",
    "playing.suggestedBlunderer": "empfohlen",
    "playing.teachingLinkCopied": "Lehrlink kopiert",
    "playing.teamA": "Name Mannschaft A",
    "playing.teamB": "Name Mannschaft B",
    "playing.teamBattleNoTeamsYet": "Die Teams sind noch nicht eingerichtet. Bitten Sie die Mitarbeiter, vor dem Beitritt Teams hinzuzufügen.",
    "playing.undoCheckIn": "Rückgängig machen",
    "playing.viewAllYourMoves": "Sehen Sie sich alle Ihre Bewegungen an",
    "playing.waitingForOpponentDraw": "Warten auf den Gegner…",
    "playing.waitingForOpponentTakeback": "Warten auf den Gegner…",
    "playing.wins": "Siege",
    "playing.yourMoveMoreHint": "Weitere Spiele warten auf Sie",
    "playing.yourMoveStrip": "Ihr Umzug",
    "playing.yourResult": "Ihr Ergebnis",
    "playing.yourResultPlace": "#{{place}} · {{score}} Punkte",
    "reports.common.batchSession": "Charge",
    "reports.common.records": "{{count}} Einträge",
    "reports.common.selectLevelFirst": "Wählen Sie zunächst eine Ebene aus, um nach Stapel zu filtern",
    "reports.dataExport.downloadPlaying": "playing-games.csv herunterladen",
    "reports.dataExport.exportPlayingFailed": "Spielplattform-Export fehlgeschlagen.",
    "reports.dataExport.playingGames": "Spielplattform-Partien",
    "reports.dataExport.playingGamesDesc": "Schachpartien (PGN, Ergebnis, Uhren) für den ausgewählten Schüler — für DSAR-/Portabilitätspakete.",
    "reports.dataExport.playingStudentRequired": "Wählen Sie einen Schüler zum Export der Spielplattform-Partien.",
    "reports.paymentsDue.statusOk": "OK",
    "reports.settingsLoadFailed": "Die Berichtseinstellungen konnten nicht geladen werden",
    "reports.settingsLoadFailedHint": "Berichtseinstellungen konnten nicht aktualisiert werden. Die Verfügbarkeit unten kann veraltet sein.",
    "sessions.verifyAttendanceFailed": "Anwesenheit konnte nicht geprüft werden. Abschließen ist blockiert, bis dies gelingt — aktualisieren und erneut versuchen.",
    "settings.email.testCompleted": "Test abgeschlossen. Zustellung konnte nicht vollständig bestätigt werden — Spam/Werbung prüfen.",
    "settings.email.testSmtpOnly": "SMTP hat die Nachricht angenommen, die Zustellung wurde jedoch nicht vollständig bestätigt.",
    "settings.email.testVerifiedSent": "Bestätigt: Nachricht vom SMTP akzeptiert und im Ordner „Gesendet“ gefunden ({{seconds}}s). Empfänger sollten Posteingang und Spam prüfen.",
    "settings.holidays.emailPreview.roles.Other": "Sonstiges",
    "settings.notifications.channelStatusLoadFailed": "Der Status des WhatsApp-/E-Mail-Kanals konnte nicht aktualisiert werden. Die Verfügbarkeit des Schalters ist möglicherweise veraltet. Aktualisieren Sie die Seite.",
    "settings.notifications.loadFailed": "Benachrichtigungseinstellungen konnten nicht geladen werden.",
    "settings.payment.eventStatus.FAILED": "Fehlgeschlagen",
    "settings.payment.eventStatus.PENDING": "Ausstehend",
    "settings.payment.eventStatus.SUCCESS": "Erfolgreich",
    "settings.payment.gateways.mollie.keyIdLabel": "Mollie-Profil-ID (wahlfrei)",
    "settings.payment.gateways.mollie.keyIdPlaceholder": "pfl_… oder leer lassen",
    "settings.payment.gateways.mollie.keySecretLabel": "Mollie API-Schlüssel",
    "settings.payment.gateways.mollie.keySecretPlaceholder": "test_… oder live_…",
    "settings.payment.gateways.mollie.subtitle": "iDEAL · Bancontact · Karten · SEPA (Europa)",
    "settings.payment.gateways.mollie.webhookLabel": "Nicht verwendet (Mollie prüft per API-Abruf)",
    "settings.payment.gateways.mollie.webhookPlaceholder": "",
    "settings.payment.gateways.paypal.keyIdLabel": "PayPal-Client-ID",
    "settings.payment.gateways.paypal.keyIdPlaceholder": "Client-ID von developer.paypal.com",
    "settings.payment.gateways.paypal.keySecretLabel": "PayPal-Client-Geheimnis",
    "settings.payment.gateways.paypal.keySecretPlaceholder": "Client-Geheimnis",
    "settings.payment.gateways.paypal.subtitle": "PayPal-Guthaben · Karten",
    "settings.payment.gateways.paypal.webhookLabel": "PayPal Webhook-ID",
    "settings.payment.gateways.paypal.webhookPlaceholder": "Webhook-ID von developer.paypal.com",
    "settings.payment.gateways.razorpay.keyIdLabel": "Razorpay-Schlüssel-ID",
    "settings.payment.gateways.razorpay.keyIdPlaceholder": "rzp_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.razorpay.keySecretLabel": "Razorpay-Geheimschlüssel",
    "settings.payment.gateways.razorpay.keySecretPlaceholder": "Razorpay-Geheimschlüssel",
    "settings.payment.gateways.razorpay.subtitle": "UPI · Karten · Online-Banking · Geldbörsen",
    "settings.payment.gateways.razorpay.webhookLabel": "Razorpay Webhook-Geheimnis (optionaler Backup)",
    "settings.payment.gateways.razorpay.webhookPlaceholder": "Im Razorpay-Dashboard → Webhooks",
    "settings.payment.gateways.stripe.keyIdLabel": "Öffentlicher Stripe-Schlüssel",
    "settings.payment.gateways.stripe.keyIdPlaceholder": "pk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.keySecretLabel": "Geheimer Stripe-Schlüssel",
    "settings.payment.gateways.stripe.keySecretPlaceholder": "sk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.subtitle": "Karten · Apple Pay · Google Pay · lokale Methoden",
    "settings.payment.gateways.stripe.webhookLabel": "Stripe-Webhook-Signaturgeheimnis",
    "settings.payment.gateways.stripe.webhookPlaceholder": "whsec_xxxxxxxxxxxxxxxx",
    "settings.whatsapp.messageTypes.ABSENCE_ALERT_STUDENT": "Abwesenheitsmeldung (Schüler)",
    "settings.whatsapp.messageTypes.CLASSROOM_STARTED_STUDENT": "Unterricht gestartet (Schüler)",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_DEADLINE_REMINDER": "Fernschach-Frist-Erinnerung",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_YOUR_MOVE": "Fernschach — Ihr Zug",
    "settings.whatsapp.messageTypes.FEE_REMINDER_STUDENT": "Gebührenerinnerung (Schüler)",
    "settings.whatsapp.messageTypes.HOLIDAY_ANNOUNCEMENT": "Feiertagsankündigung",
    "settings.whatsapp.messageTypes.LOW_BALANCE_ADMIN": "Niedriger Kontostand (Admin)",
    "settings.whatsapp.messageTypes.LOW_BALANCE_STUDENT": "Niedriger Kontostand (Schüler)",
    "settings.whatsapp.messageTypes.PENDING_SESSIONS_COACH": "Offene Sitzungen (Trainer)",
    "settings.whatsapp.messageTypes.SESSION_CANCELLED_STUDENT": "Sitzung abgesagt (Schüler)",
    "settings.whatsapp.messageTypes.SESSION_REMINDER_STUDENT": "Sitzungserinnerung (Schüler)",
    "settings.whatsapp.msgStatus.FAILED": "Fehlgeschlagen",
    "settings.whatsapp.msgStatus.PENDING": "Ausstehend",
    "settings.whatsapp.msgStatus.PROCESSING": "In Bearbeitung",
    "settings.whatsapp.msgStatus.QUEUED": "In Warteschlange",
    "settings.whatsapp.msgStatus.SENT": "Gesendet",
    "settings.whatsapp.queueStatus.FAILED": "Fehlgeschlagen",
    "settings.whatsapp.queueStatus.PENDING": "Ausstehend",
    "settings.whatsapp.queueStatus.PROCESSING": "In Bearbeitung",
    "settings.whatsapp.queueStatus.QUEUED": "In Warteschlange",
    "settings.whatsapp.queueStatus.SENT": "Gesendet",
    "wallet.txnReasons.unknown": "{{reason}}",
    "walletStaff.credit": "Gutschrift",
    "walletStaff.debit": "Belastung",
    "walletStaff.paymentMethodsLoadFailed": "Zahlungsarten konnten nicht geladen werden — Fallback wird verwendet.",
    "walletStaff.refundConfirm": "{{amount}} von diesem Wallet erstatten? Dies kann hier nicht rückgängig gemacht werden."
  },
  "fr": {
    "attendance.coachFallback": "Coach #{{id}}",
    "attendance.partialDetailsHint": "Certains détails de participation n'ont pas pu être entièrement chargés. La liste est peut-être incomplète : actualisez-la pour réessayer.",
    "attendance.sessionDetailsLoadFailed": "Impossible de charger les détails de la séance. La liste peut encore fonctionner ; actualisez pour réessayer.",
    "attendance.studentFallback": "Élève #{{id}}",
    "attendance.verifyAttendanceFailed": "Impossible de vérifier la présence. La finalisation est bloquée tant que cela échoue — actualisez et réessayez.",
    "attendance.walkInsLoadFailed": "Impossible de charger les élèves walk-in. Actualisez et réessayez.",
    "auth.accountDisabled": "Ce compte a été désactivé.",
    "auth.checkingSetup": "Vérification de la configuration de l'académie…",
    "calendar.holidaysLoadFailed": "Impossible de charger les jours fériés. Le calendrier peut ressembler à une semaine de travail normale.",
    "calendar.viewingOtherCoachNoHost": "Affichage d’un autre coach — ouvrez votre calendrier pour animer.",
    "charts.academyByBranch": "Brut par succursale",
    "charts.academyByBranchHint": "Comparer le chiffre d’affaires brut par succursale",
    "charts.academyMonthlyTrend": "Tendance des revenus mensuels",
    "charts.academyMonthlyTrendHint": "Paiements bruts, des académies et des entraîneurs par mois",
    "charts.academyRevenueSplit": "Répartition des revenus",
    "charts.academyRevenueSplitHint": "Part académie vs coach",
    "charts.atRisk": "À risque",
    "charts.atRiskCount": "{{count}} étudiants",
    "charts.atRiskRateHint": "Taux les plus bas dans la liste actuelle",
    "charts.atRiskShare": "Part à risque",
    "charts.atRiskShareHint": "Pourcentage de la liste nécessitant une attention particulière",
    "charts.atRiskTiers": "Niveaux de risque",
    "charts.attendanceBuckets": "Répartition du pourcentage de fréquentation",
    "charts.attendanceBucketsHint": "Élèves par tranche de taux de présence",
    "charts.attendanceRates": "Taux de fréquentation",
    "charts.attendanceSnapshot": "Aperçu de la présence",
    "charts.attendanceWtd": "Présence cette semaine",
    "charts.childAttendance": "Présence de l’enfant",
    "charts.childRating": "Évaluation des enfants",
    "charts.coachGrossCompare": "Brut par coach",
    "charts.coachGrossCompareHint": "Comparer le chiffre d’affaires brut des coachs",
    "charts.coachRevenueTrend": "Revenu par jour",
    "charts.coachRevenueTrendHint": "Revenus bruts, des académies et des entraîneurs sur la période",
    "charts.commissionSplit": "Répartition des commissions",
    "charts.commissionSplitHint": "Part académie vs coach",
    "charts.completedSessionsWeek": "Des séances terminées cette semaine",
    "charts.defaultSeries": "Valeur",
    "charts.gameRecord": "Record de jeu",
    "charts.healthy": "En bonne santé",
    "charts.hoursByWeekday": "Horaires par jour de semaine",
    "charts.legend": "Légende du graphique",
    "charts.manageBranches": "Succursales",
    "charts.managerBranchHint": "Étudiants actifs dans vos succursales",
    "charts.noAtRiskData": "Aucune donnée à risque à cartographier pour l'instant",
    "charts.noAttendanceBucketData": "Aucune ligne d’élève à afficher",
    "charts.noAttendanceMarks": "Pas encore de présence cette semaine",
    "charts.noAttendanceYet": "Aucune séance terminée cette semaine pour l'instant",
    "charts.noBranchAmountData": "Aucun montant de succursale à afficher",
    "charts.noBranchData": "Aucune donnée d'inscription dans les succursales pour l'instant",
    "charts.noBranchEnrollmentYet": "Les étudiants sont visibles mais aucun n'est encore inscrit dans vos branches",
    "charts.noCoachData": "Aucune répartition par coach à afficher",
    "charts.noDataYet": "Aucune donnée à tracer pour l'instant",
    "charts.noGamesYet": "Aucun jeu classé pour l'instant",
    "charts.noHealthData": "Pas encore de données sur la santé des étudiants",
    "charts.noHoursYet": "Aucune heure de cours enregistrée cette semaine",
    "charts.noMonthlyData": "Aucune répartition mensuelle à afficher",
    "charts.noPlayingYet": "Aucune activité de jeu pour l'instant",
    "charts.noRecentMarks": "Aucune note de présence récente",
    "charts.noSlotData": "Aucun créneau de présence à afficher",
    "charts.noSplitData": "Aucune répartition de commission à afficher",
    "charts.noStatementStatusData": "Aucun statut de relevé à tracer",
    "charts.noStatusData": "Aucun groupe de statut à afficher",
    "charts.noStudentsInYourBranches": "Aucun étudiant inscrit dans vos branches pour le moment",
    "charts.noTrendData": "Aucun revenu quotidien à afficher",
    "charts.notEnrolled": "Non inscrit",
    "charts.open": "Ouvrir",
    "charts.paymentsDueByBranch": "Montant dû par succursale",
    "charts.paymentsDueByBranchHint": "Montants en souffrance regroupés par succursale",
    "charts.paymentsDueStatus": "Répartition des statuts de paiement",
    "charts.paymentsDueStatusHint": "Élèves en retard, solde bas et OK",
    "charts.playingPeek": "Activité de jeu",
    "charts.presentVsAbsent": "Présent vs absent",
    "charts.presentVsAbsentHint": "Créneaux de fréquentation totaux sur la période",
    "charts.rate": "Taux",
    "charts.recentMarks": "Marques récentes",
    "charts.statementStatusMix": "Statut des e-mails de relevé",
    "charts.statementStatusMixHint": "Envoyé, en attente, en échec et non envoyé",
    "charts.studentHealth": "Santé des élèves",
    "charts.studentHealthHint": "Liste à risque ou en bonne santé",
    "charts.students": "Élèves",
    "charts.studentsByBranch": "Étudiants par site",
    "charts.studentsByBranchHint": "Étudiants inscrits par site (y compris non inscrits)",
    "charts.tierCriticalShort": "Critique",
    "charts.tierHighShort": "Élevé",
    "charts.tierMediumShort": "Moyen",
    "charts.unsolvedAttempts": "Autres tentatives",
    "charts.viewAtRisk": "Vue à risque",
    "charts.viewHistory": "Histoire",
    "charts.viewStudents": "Étudiants",
    "charts.weekToDate": "Semaine à ce jour",
    "classroom.live.notStartedHint": "Votre coach n'a pas encore commencé ce cours en ligne.",
    "classroom.live.notStartedYet": "Pas encore commencé",
    "classroom.meeting.admitAll": "Admettez tout",
    "classroom.meeting.admitFailed": "Impossible d'admettre des étudiants en attente.",
    "classroom.meeting.admitOne": "Admettre",
    "classroom.meeting.admitting": "Admettre…",
    "classroom.meeting.connectedHint": "En direct dans ChessDesk",
    "classroom.meeting.embedAuthMissing": "Identifiants de réunion indisponibles. Vérifiez les identifiants Zoom Meeting SDK sous Salle de classe → Zoom.",
    "classroom.meeting.embedUnavailableRetry": "Impossible de démarrer la vidéo dans le navigateur. Réessayez ou utilisez Ouvrir dans l’app Zoom.",
    "classroom.meeting.guest": "Invité",
    "classroom.meeting.hostZakMissing": "Identifiants hôte manquants. Définissez l’e-mail hôte Zoom sous Salle de classe → Paramètres sur un utilisateur Zoom licencié, puis réessayez.",
    "classroom.meeting.notActuallyHost": "Connexion réussie, mais Zoom n’a pas accordé le rôle d’hôte. Définissez l’e-mail hôte Zoom sous Salle de classe → Paramètres sur votre compte Zoom licencié, quittez, puis rejoignez en tant que coach.",
    "classroom.meeting.scriptLoadFailed": "Échec du chargement du script Zoom : {{src}}",
    "classroom.meeting.sdkLoadFailed": "Échec du chargement du Zoom Meeting SDK.",
    "classroom.meeting.waitingForHost": "En attente que votre entraîneur démarre le cours. Restez sur cette page — vous entrerez quand il rejoindra.",
    "classroom.meeting.waitingGuest": "Invité",
    "classroom.meeting.waitingRoomTitle": "{{count}} étudiant(s) dans la salle d'attente",
    "classroom.meeting.zoomJoinFailed": "Échec de la connexion Zoom",
    "classroom.zoom.clientIdPlaceholder": "par ex. AbCdEfGh...",
    "classroom.zoom.meetingSdkHeading": "Vidéo intégrée (Meeting SDK)",
    "common.academyLogo": "Logo de l'Académie",
    "common.backHome": "Retour à la maison",
    "common.currencyWord": "devise",
    "common.guest": "Invité",
    "common.listLoadFailed": "Impossible de charger cette liste. Actualisez et réessayez.",
    "common.noData": "Aucun utilisateur trouvé.",
    "common.notSet": "non défini",
    "common.optional": "Facultatif",
    "common.optionsLoadFailed": "Impossible de charger les options. Actualisez la page ou réessayez.",
    "common.pageNotFound": "Page introuvable",
    "common.pageNotFoundHint": "Ce lien ne correspond à aucune page de l'application. Vérifiez l'URL ou rentrez chez vous.",
    "common.period": "période",
    "common.required": "Requis",
    "common.retry": "Réessayer",
    "common.rowN": "Ligne {{n}}",
    "common.unknownError": "Erreur inconnue",
    "enrollments.activateFailed": "Impossible d’activer cette inscription.",
    "enrollments.form.noStudentMatches": "Aucun élève ne correspond à votre recherche.",
    "enrollments.form.noStudentsAvailable": "Aucun élève disponible à inscrire.",
    "enrollments.paymentModal.coachAskTopUp": "Demandez à un manager ou admin de recharger le portefeuille de cet élève, puis actualisez le solde.",
    "enrollments.renewMissingData": "Renouvellement impossible — données élève, niveau ou groupe manquantes.",
    "exports.batchId": "ID du groupe",
    "exports.batchName": "Nom du groupe",
    "exports.branch": "Succursale",
    "exports.branchId": "ID de succursale",
    "exports.code": "Code",
    "exports.email": "E-mail",
    "exports.id": "ID",
    "exports.level": "Niveau",
    "exports.levelId": "ID de niveau",
    "exports.manager": "Directeur",
    "exports.mode": "Mode",
    "exports.name": "Nom",
    "exports.phone": "Téléphone",
    "exports.roles": "Rôles",
    "exports.scope": "Portée",
    "exports.scopeBatch": "Groupe n° {{id}}",
    "exports.scopeBranch": "Succursale n° {{id}}",
    "exports.scopeGlobal": "Mondial",
    "exports.scopeLevel": "Niveau #{{id}}",
    "exports.sessionDays": "Jours de séance",
    "exports.sheetGeneric": "Feuille",
    "exports.sheetReport": "Rapport",
    "exports.status": "Statut",
    "exports.userId": "ID de l'utilisateur",
    "exports.username": "Nom d'utilisateur",
    "exports.value": "Valeur",
    "forms.address.citiesLoadFailed": "Impossible de charger les villes — vous pouvez toujours saisir le nom de la ville.",
    "forms.batch.loadFailed": "Impossible de charger ce lot.",
    "forms.branch.loadFailed": "Impossible de charger ce site.",
    "forms.common.back": "Dos",
    "forms.level.loadFailed": "Impossible de charger ce niveau.",
    "forms.student.eloPlaceholder": "par ex. 1650",
    "forms.student.fideIdPlaceholder": "p. ex. 1503014",
    "forms.student.fideTitlePlaceholder": "par ex. CM, FM, IM, GM",
    "levels.unnamed": "Niveau",
    "notificationBell.countUnknown": "Nombre de non lus indisponible",
    "notificationBell.markReadFailed": "Impossible de marquer comme lu. Réessayez.",
    "notifications.content.reviewGame": "Revoir le jeu",
    "notificationsPage.markAllFailed": "Impossible de tout marquer comme lu. Réessayez.",
    "pages.adminDashboard.statsLoadFailed": "Les statistiques du tableau de bord n'ont pas pu être chargées. Les chiffres ci-dessous peuvent être incomplets : actualisez-les pour réessayer.",
    "pages.coaches.manageAssignments.coachLabel": "Coach : {{name}}",
    "pages.discountForm.codePlaceholder": "ex. SIBLING_10, EARLY_BIRD",
    "pages.discountForm.flatValuePlaceholder": "ex. 500",
    "pages.discountForm.namePlaceholder": "ex. Remise fratrie, Offre early bird",
    "pages.discountForm.percentValuePlaceholder": "ex. 10",
    "pages.enrollmentDetail.afterDiscountApplied": "Après remise de {{value}}",
    "pages.enrollmentDetail.batchLoadFailed": "Impossible de charger les détails du groupe. Les frais et infos de période peuvent être incomplets.",
    "pages.enrollmentDetail.receivers.OTHERS": "Autres",
    "pages.enrollmentDetail.receivers.USER": "Élève / famille",
    "pages.enrollmentDetail.types.REGULAR": "Régulière",
    "pages.enrollmentDetail.types.SINGLE_SESSION": "Séance unique",
    "pages.feePlanForm.groupTypes.GROUP": "Groupe",
    "pages.feePlanForm.groupTypes.ONE_TO_ONE": "Individuel",
    "pages.feePlanForm.planTypes.MONTHLY": "Mensuel",
    "pages.feePlanForm.planTypes.PACKAGE": "Forfait",
    "pages.feePlanForm.planTypes.PER_SESSION": "Par séance",
    "pages.managerDashboard.statsLoadFailed": "Les statistiques du tableau de bord n'ont pas pu être chargées. Les chiffres ci-dessous peuvent être incomplets : actualisez-les pour réessayer.",
    "pages.notifications.classroomStarted": "Alertes de début de cours en direct",
    "pages.parentHome.childPlayingLive": "Je joue en live maintenant",
    "pages.parentHome.noPlayingYet": "Aucun jeu de plateforme de jeu pour l'instant pour cet enfant.",
    "pages.parentHome.partialSnapshot": "Certaines données de l’aperçu enfant n’ont pas pu être chargées. Les chiffres peuvent être incomplets — actualisez pour réessayer.",
    "pages.parentHome.playingLoadFailed": "Impossible de charger l'activité de la plateforme de jeu.",
    "pages.parentHome.playingPlatform": "Plateforme de jeu",
    "pages.parentHome.snapshotLoadFailed": "Impossible de charger l’aperçu de l’enfant. Actualisez pour réessayer.",
    "pages.parentHome.viewPlayProfile": "Afficher le profil de jeu",
    "pages.parentHome.watchLive": "Regarder en direct",
    "pages.sessionStatement.transactionsCount": "{{count}} opérations",
    "pages.studentBulkImport.cols.addressLine1": "Adresse postale, numéro d'appartement/de maison",
    "pages.studentBulkImport.cols.addressLine2": "Informations d'adresse supplémentaires : point de repère, zone, etc.",
    "pages.studentBulkImport.cols.city": "Ville",
    "pages.studentBulkImport.cols.country": "Pays",
    "pages.studentBulkImport.cols.dob": "Date de naissance au format régional de l'académie ({{format}}) ou AAAA-MM-JJ",
    "pages.studentBulkImport.cols.email": "Adresse e-mail valide – doit être unique",
    "pages.studentBulkImport.cols.firstName": "Lettres Unicode autorisées (par exemple François, Müller)",
    "pages.studentBulkImport.cols.gender": "MÂLE | FEMME | AUTRE (majuscule)",
    "pages.studentBulkImport.cols.lastName": "Lettres Unicode autorisées (par exemple Dupont, van der Berg)",
    "pages.studentBulkImport.cols.middleName": "Facultatif — accents, espaces, tirets, apostrophes OK",
    "pages.studentBulkImport.cols.password": "Facultatif : remplace le mot de passe par défaut pour cette ligne",
    "pages.studentBulkImport.cols.phoneNumber": "Numéro local ou international complet (+…). Les numéros locaux utilisent le pays de l'académie dans les paramètres régionaux.",
    "pages.studentBulkImport.cols.pincode": "Code PIN/ZIP",
    "pages.studentBulkImport.cols.state": "État/province",
    "pages.studentBulkImport.cols.username": "Nom d'utilisateur de connexion unique (par exemple, rahul.sharma)",
    "pages.studentBulkImport.csvGuide": "Guide du format CSV",
    "pages.studentBulkImport.duplicateSkipped": "Ignoré — un élève avec ce nom d’utilisateur ou cet e-mail existe déjà",
    "pages.studentBulkImport.processingRow": "Ligne {{current}} sur {{total}} — {{name}}",
    "pages.studentBulkImport.unknownError": "Erreur inconnue",
    "pages.studentBulkImport.validation.dobFormat": "dob doit être {{format}} ou AAAA-MM-JJ",
    "pages.studentBulkImport.validation.dobInvalid": "date de naissance n'est pas une date valide",
    "pages.studentBulkImport.validation.emailInvalid": "l'e-mail \"{{value}}\" n'est pas valide",
    "pages.studentBulkImport.validation.genderInvalid": "le sexe \"{{value}}\" n'est pas valide ; doit être MASCULIN, FÉMININ ou AUTRE",
    "pages.studentBulkImport.validation.genderRequired": "le sexe est requis (HOMME / FEMME / AUTRE)",
    "pages.studentBulkImport.validation.invalidName": "{{field}} doit être un nom valide (lettres, espaces, traits d'union, apostrophes ; accents autorisés)",
    "pages.studentBulkImport.validation.phoneInvalid": "Le numéro de téléphone n'est pas valide",
    "pages.studentBulkImport.validation.required": "{{field}} est obligatoire",
    "pages.studentDashboard.partialLoad": "Certaines données du tableau de bord n'ont pas pu être chargées. Les chiffres peuvent être incomplets : actualisez-les pour réessayer.",
    "pages.userDetails.genderFemale": "Femme",
    "pages.userDetails.genderMale": "Homme",
    "pages.userDetails.genderOther": "Autre",
    "pages.wallet.gatewaysLoadFailed": "Impossible de vérifier les options de paiement en ligne. Actualisez et réessayez.",
    "pages.wallet.methodCash": "Espèces",
    "pages.wallet.methodsLoadFailed": "Les méthodes de paiement n'ont pas pu être chargées. La liste des modes peut être incomplète.",
    "pages.wallet.unsupportedGateway": "Réponse de passerelle de paiement non prise en charge.",
    "pages.walletTopup.noManagedStudents": "Aucun élève dans vos succursales gérées pour l’instant. Ajoutez ou inscrivez d’abord des élèves.",
    "pages.walletTopup.staffLoadFailed": "Impossible de charger la liste du personnel. Actualisez et réessayez.",
    "pages.walletTopup.studentsLoadFailed": "Impossible de charger les élèves. Actualisez et réessayez.",
    "parent.childrenLoadFailed": "Impossible de charger les étudiants liés",
    "parent.childrenLoadFailedHint": "Ce n’est pas la même chose que de ne pas avoir d’enfants. Actualisez pour réessayer.",
    "phone.digitsRequired": "Le numéro de téléphone doit contenir des chiffres.",
    "phone.required": "Le numéro de téléphone est requis.",
    "playing.academyStudents": "Étudiants de l'Académie",
    "playing.assignPractice": "Devoirs",
    "playing.assignSelectedPack": "Attribuer la sélection",
    "playing.assignToStudent": "Attribuer à",
    "playing.backToHub": "Retour au hub",
    "playing.checkIn": "Enregistrement",
    "playing.checkInFailed": "Impossible de mettre à jour l'enregistrement.",
    "playing.checkedIn": "Dans",
    "playing.checkedInCount": "{{checked}}/{{total}} enregistrés",
    "playing.coachBoardShortcut": "Échiquier pédagogique + Classe",
    "playing.coachDebriefBoards": "Compte rendu de l'entraîneur — tous les tableaux",
    "playing.coachDesk": "Bureau",
    "playing.coachRosterPicker": "Étudiant sur liste",
    "playing.coachRosterPickerMe": "Mes propres jeux",
    "playing.confirmMoveAction": "Jouer le coup",
    "playing.copyStandings": "Copier le classement",
    "playing.copyStudyPgn": "Copier le PGN annoté",
    "playing.copyTeachingLink": "Copier le lien pédagogique",
    "playing.createAndOpen": "Créer et ouvrir",
    "playing.createBan": "Interdire un joueur",
    "playing.createDraft": "Enregistrer le brouillon",
    "playing.dismissPack": "Ignorer le pack",
    "playing.draftFromMistakes": "Draft pack du jeu",
    "playing.draws": "Tirages",
    "playing.fairnessTeachingHint": "{{n}} coups signalés (niveau max. : {{level}}). À utiliser pour l’enseignement — ouvrez le fair-play si besoin.",
    "playing.friendlyRematch": "Rematch amical",
    "playing.friendlyRematchHint": "En dehors de l'événement · occasionnel (non classé)",
    "playing.gameType.VS_COMPUTER": "vs Ordinateur",
    "playing.increment": "Incrément (s)",
    "playing.liftBan": "Interdiction de lever",
    "playing.livePeekLoadFailed": "Impossible de charger les jeux en direct pour le moment.",
    "playing.loadRecentGame": "Charger un jeu récent",
    "playing.loadRecentGamePlaceholder": "Choisissez un jeu terminé…",
    "playing.losses": "Pertes",
    "playing.matchmakingPausedShort": "Matchmaking suspendu – réessayez la vérification de l'interdiction",
    "playing.material": "Matériel",
    "playing.mistakeCount": "{{n}} erreurs",
    "playing.noRecentGamesToLoad": "Aucun jeu terminé à charger pour l'instant. Collez un PGN ou définissez un FEN ci-dessous.",
    "playing.nudgeSent": "Rappel envoyé.",
    "playing.openCoachBoard": "Ouvert à bord des autocars",
    "playing.openFairPlay": "Examen ouvert du fair-play",
    "playing.openForRegistration": "Ouvert aux inscriptions",
    "playing.openRegistrationNow": "Ouvrez l'inscription maintenant (sinon enregistrez-la comme brouillon)",
    "playing.openings.benoni_benko_path": "Voie Benoni / Benko",
    "playing.openings.birds_opening": "Ouverture Bird",
    "playing.openings.caro_kann_advance": "Caro-Kann — Avance",
    "playing.openings.caro_kann_classical": "Caro-Kann — Classique",
    "playing.openings.dutch_defence": "Défense hollandaise",
    "playing.openings.english_1_e5": "Anglaise — 1…e5",
    "playing.openings.english_1_e6": "Anglaise — 1…e6",
    "playing.openings.english_anglo_indian": "Anglaise — Anglo-indienne",
    "playing.openings.english_opening": "Ouverture anglaise",
    "playing.openings.english_symmetrical": "Anglaise — Symétrique",
    "playing.openings.french_advance": "Française — Avance",
    "playing.openings.french_classical": "Française — Classique",
    "playing.openings.french_exchange": "Française — Échange",
    "playing.openings.giuoco_piano_open": "Giuoco Piano — Ouvert",
    "playing.openings.indian_defence": "Défense indienne",
    "playing.openings.kings_indian_defence": "Défense est-indienne",
    "playing.openings.kings_knight_two_knights_path": "Cavalier du roi — voie des deux cavaliers",
    "playing.openings.london_system_main_line": "Système London — variante principale",
    "playing.openings.nimzo_indian_defence": "Défense nimzo-indienne",
    "playing.openings.nimzo_indian_path": "Voie nimzo-indienne",
    "playing.openings.nimzo_larsen_attack": "Attaque Nimzo-Larsen",
    "playing.openings.queens_gambit_accepted": "Gambit dame accepté",
    "playing.openings.queens_gambit_declined_london_hybrid": "Gambit dame refusé — hybride London",
    "playing.openings.queens_indian_nimzo_path": "Voie ouest-indienne / Nimzo",
    "playing.openings.r_ti_opening": "Ouverture Réti",
    "playing.openings.ruy_lopez_morphy_closed": "Espagnole — Morphy, fermée",
    "playing.openings.ruy_lopez_morphy_defence": "Espagnole — défense Morphy",
    "playing.openings.scandinavian_2_nf6": "Scandinave — 2…Cf6",
    "playing.openings.scandinavian_2_qxd5": "Scandinave — 2…Dxd5",
    "playing.openings.sicilian_2_d6": "Sicilienne — 2…d6",
    "playing.openings.sicilian_2_e6": "Sicilienne — 2…e6",
    "playing.openings.sicilian_2_nc6": "Sicilienne — 2…Cc6",
    "playing.openings.sicilian_2_nf3": "Sicilienne — 2.Cf3",
    "playing.openings.sicilian_classical_path": "Sicilienne — voie classique",
    "playing.openings.sicilian_dragon": "Sicilienne — Dragon",
    "playing.openings.sicilian_dragon_classical": "Sicilienne — Dragon, classique",
    "playing.openings.sicilian_dragon_yugoslav": "Sicilienne — Dragon, yougoslave",
    "playing.openings.sicilian_hyperaccelerated": "Sicilienne — Hyperaccélérée",
    "playing.openings.sicilian_najdorf": "Sicilienne — Najdorf",
    "playing.openings.sicilian_najdorf_english_attack": "Sicilienne — Najdorf, attaque anglaise",
    "playing.openings.slav_defence": "Défense slave",
    "playing.openings.van_geet_opening": "Ouverture Van Geet",
    "playing.packAssigned": "Vous avez assigné {{n}} énigmes de devoirs.",
    "playing.parentChallengeBlockedHint": "Les parents peuvent jouer contre l’ordinateur et surveiller leurs enfants : les défis humains sont réservés aux joueurs.",
    "playing.parentChallengeBlockedTitle": "Les défis sont pour les joueurs",
    "playing.parentChallengeHint": "Les défis sont envoyés depuis le compte de votre enfant, pas le vôtre.",
    "playing.parentChallengeToastHint": "Les parents ne jouent pas à des jeux humains : refusez cette invitation ou jouez contre l'ordinateur depuis le hub.",
    "playing.pgn.clubGame": "Partie de club",
    "playing.pickTeam": "Choisissez une équipe",
    "playing.playersCount": "{{n}} joueurs",
    "playing.privateGame": "Privé",
    "playing.privateLinkHint": "Cette partie est privée — le lien copié ne fonctionne que pour les deux joueurs (et le personnel).",
    "playing.profile": "Profil",
    "playing.quality.best": "Meilleur",
    "playing.quality.blunder": "Gaffe",
    "playing.quality.brilliant": "Brillant",
    "playing.quality.good": "Bon",
    "playing.quality.inaccuracy": "Imprécision",
    "playing.quality.mistake": "Erreur",
    "playing.recentGamesLoadFailed": "Impossible de charger les jeux récents pour le sélecteur.",
    "playing.rematchNightHint": "Défis amicaux (non classés) en dehors de l'événement",
    "playing.rematchNightOpponents": "Adversaires de la soirée revanche",
    "playing.removePlayer": "Retirer",
    "playing.removePlayerConfirm": "Supprimer {{name}} de cette soirée club ?",
    "playing.removePlayerFailed": "Impossible de supprimer le joueur.",
    "playing.reviewReadyStrip": "Révision prête",
    "playing.saveDue": "Enregistrer l’échéance",
    "playing.saveFailed": "Impossible d'enregistrer.",
    "playing.scrubToMistake": "Frottez jusqu'à une erreur avec un meilleur mouvement pour enregistrer un pli.",
    "playing.selectStudent": "Sélectionnez un étudiant…",
    "playing.solved": "Résolu",
    "playing.speed.BLITZ": "Blitz",
    "playing.speed.BULLET": "Bullet",
    "playing.speed.CLASSICAL": "Classique",
    "playing.speed.CORRESPONDENCE": "Correspondance",
    "playing.speed.RAPID": "Rapide",
    "playing.startingNow": "À partir de maintenant",
    "playing.startsAt": "Commence à",
    "playing.startsIn": "Commence dans {{when}}",
    "playing.stockfish.disabled": "L’analyse par moteur est désactivée sur ce serveur.",
    "playing.stockfish.notStarted": "Le moteur d’échecs n’est pas encore prêt.",
    "playing.stockfish.unavailable": "L’analyse par moteur est indisponible pour le moment.",
    "playing.studyMistakes": "Erreurs d'étude",
    "playing.studyOnCoachBoard": "Étude",
    "playing.studyPgnCopied": "PGN annoté copié",
    "playing.studySource": "Source de l'étude",
    "playing.suggestedBlunderer": "suggéré",
    "playing.teachingLinkCopied": "Lien pédagogique copié",
    "playing.teamBattleNoTeamsYet": "Les équipes ne sont pas encore constituées : demandez au personnel d'ajouter des équipes avant de les rejoindre.",
    "playing.undoCheckIn": "Défaire",
    "playing.viewAllYourMoves": "Visualisez tous vos mouvements",
    "playing.waitingForOpponentDraw": "En attendant l'adversaire…",
    "playing.waitingForOpponentTakeback": "En attendant l'adversaire…",
    "playing.wins": "Victoires",
    "playing.yourMoveMoreHint": "Plus de jeux vous attendent",
    "playing.yourMoveStrip": "Votre déménagement",
    "playing.yourResult": "Votre résultat",
    "playing.yourResultPlace": "#{{place}} · {{score}} points",
    "privacy.cookies.jwt": "<strong>JWT</strong> (localStorage) — connexion.",
    "reports.common.batchSession": "Lot",
    "reports.common.records": "{{count}} enregistrements",
    "reports.common.selectLevelFirst": "Sélectionnez d'abord un niveau pour filtrer par lot",
    "reports.dataExport.downloadPlaying": "Télécharger playing-games.csv",
    "reports.dataExport.exportPlayingFailed": "Échec de l’export de la plateforme de jeu.",
    "reports.dataExport.playingGames": "Parties de la plateforme de jeu",
    "reports.dataExport.playingGamesDesc": "Parties d’échecs (PGN, résultat, pendules) pour l’élève sélectionné — pour packs DSAR / portabilité.",
    "reports.dataExport.playingStudentRequired": "Choisissez un élève pour exporter les parties de la plateforme de jeu.",
    "reports.paymentsDue.statusOk": "OK",
    "reports.settingsLoadFailed": "Impossible de charger les paramètres du rapport",
    "reports.settingsLoadFailedHint": "Les paramètres du rapport n’ont pas pu être actualisés. La disponibilité ci-dessous peut être obsolète.",
    "sessions.verifyAttendanceFailed": "Impossible de vérifier la présence. La finalisation est bloquée tant que cela échoue — actualisez et réessayez.",
    "settings.email.testCompleted": "Test terminé. La livraison n’a pas pu être entièrement vérifiée — vérifiez les indésirables.",
    "settings.email.testSmtpOnly": "SMTP a accepté le message, mais la livraison n’a pas été entièrement vérifiée.",
    "settings.email.testVerifiedSent": "Vérifié : message accepté par SMTP et trouvé dans Envoyés ({{seconds}}s). Demandez au destinataire de vérifier la boîte de réception et les indésirables.",
    "settings.holidays.emailPreview.roles.Other": "Autre",
    "settings.notifications.channelStatusLoadFailed": "Impossible d'actualiser l'état du canal WhatsApp/e-mail. La disponibilité du bouton peut être obsolète : actualisez la page.",
    "settings.notifications.loadFailed": "Impossible de charger les préférences de notification.",
    "settings.payment.eventStatus.FAILED": "Échoué",
    "settings.payment.eventStatus.PENDING": "En attente",
    "settings.payment.eventStatus.SUCCESS": "Réussi",
    "settings.payment.gateways.mollie.keyIdLabel": "ID de profil Mollie (optionnel)",
    "settings.payment.gateways.mollie.keyIdPlaceholder": "pfl_… ou laisser vide",
    "settings.payment.gateways.mollie.keySecretLabel": "Clé API Mollie",
    "settings.payment.gateways.mollie.keySecretPlaceholder": "test_… ou live_…",
    "settings.payment.gateways.mollie.subtitle": "iDEAL · Bancontact · Cartes · SEPA (Europe)",
    "settings.payment.gateways.mollie.webhookLabel": "Non utilisé (Mollie vérifie via appel API)",
    "settings.payment.gateways.mollie.webhookPlaceholder": "",
    "settings.payment.gateways.paypal.keyIdLabel": "ID client PayPal",
    "settings.payment.gateways.paypal.keyIdPlaceholder": "ID client depuis developer.paypal.com",
    "settings.payment.gateways.paypal.keySecretLabel": "Secret client PayPal",
    "settings.payment.gateways.paypal.keySecretPlaceholder": "Secret client",
    "settings.payment.gateways.paypal.subtitle": "Solde PayPal · Cartes",
    "settings.payment.gateways.paypal.webhookLabel": "ID webhook PayPal",
    "settings.payment.gateways.paypal.webhookPlaceholder": "ID webhook depuis developer.paypal.com",
    "settings.payment.gateways.razorpay.keyIdLabel": "ID de clé Razorpay",
    "settings.payment.gateways.razorpay.keyIdPlaceholder": "rzp_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.razorpay.keySecretLabel": "Clé secrète Razorpay",
    "settings.payment.gateways.razorpay.keySecretPlaceholder": "Clé secrète Razorpay",
    "settings.payment.gateways.razorpay.subtitle": "UPI · Cartes · Banque en ligne · Portefeuilles",
    "settings.payment.gateways.razorpay.webhookLabel": "Secret webhook Razorpay (sauvegarde optionnelle)",
    "settings.payment.gateways.razorpay.webhookPlaceholder": "Tableau de bord Razorpay → Webhooks",
    "settings.payment.gateways.stripe.keyIdLabel": "Clé publiable Stripe",
    "settings.payment.gateways.stripe.keyIdPlaceholder": "pk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.keySecretLabel": "Clé secrète Stripe",
    "settings.payment.gateways.stripe.keySecretPlaceholder": "sk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.subtitle": "Cartes · Apple Pay · Google Pay · méthodes locales",
    "settings.payment.gateways.stripe.webhookLabel": "Secret de signature webhook Stripe",
    "settings.payment.gateways.stripe.webhookPlaceholder": "whsec_xxxxxxxxxxxxxxxx",
    "settings.whatsapp.messageTypes.ABSENCE_ALERT_STUDENT": "Alerte d’absence (élève)",
    "settings.whatsapp.messageTypes.CLASSROOM_STARTED_STUDENT": "Cours démarré (élève)",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_DEADLINE_REMINDER": "Rappel d’échéance de correspondance",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_YOUR_MOVE": "Correspondance — à vous de jouer",
    "settings.whatsapp.messageTypes.FEE_REMINDER_STUDENT": "Rappel de frais (élève)",
    "settings.whatsapp.messageTypes.HOLIDAY_ANNOUNCEMENT": "Annonce de jour férié",
    "settings.whatsapp.messageTypes.LOW_BALANCE_ADMIN": "Solde faible (admin)",
    "settings.whatsapp.messageTypes.LOW_BALANCE_STUDENT": "Solde faible (élève)",
    "settings.whatsapp.messageTypes.PENDING_SESSIONS_COACH": "Séances en attente (coach)",
    "settings.whatsapp.messageTypes.SESSION_CANCELLED_STUDENT": "Séance annulée (élève)",
    "settings.whatsapp.messageTypes.SESSION_REMINDER_STUDENT": "Rappel de séance (élève)",
    "settings.whatsapp.msgStatus.FAILED": "Échoué",
    "settings.whatsapp.msgStatus.PENDING": "En attente",
    "settings.whatsapp.msgStatus.PROCESSING": "En cours",
    "settings.whatsapp.msgStatus.QUEUED": "En file",
    "settings.whatsapp.msgStatus.SENT": "Envoyé",
    "settings.whatsapp.queueStatus.FAILED": "Échoué",
    "settings.whatsapp.queueStatus.PENDING": "En attente",
    "settings.whatsapp.queueStatus.PROCESSING": "En cours",
    "settings.whatsapp.queueStatus.QUEUED": "En file",
    "settings.whatsapp.queueStatus.SENT": "Envoyé",
    "wallet.txnReasons.unknown": "{{reason}}",
    "walletStaff.credit": "Crédit",
    "walletStaff.debit": "Débit",
    "walletStaff.paymentMethodsLoadFailed": "Impossible de charger les modes de paiement — option de secours utilisée.",
    "walletStaff.refundConfirm": "Rembourser {{amount}} de ce portefeuille ? Irréversible depuis ici."
  },
  "nl": {
    "attendance.coachFallback": "Coach #{{id}}",
    "attendance.partialDetailsHint": "Sommige aanwezigheidsgegevens konden niet volledig worden geladen. De lijst is mogelijk onvolledig. Vernieuw de lijst om het opnieuw te proberen.",
    "attendance.sessionDetailsLoadFailed": "Kan sessiedetails niet laden. Het rooster werkt mogelijk nog; vernieuw om opnieuw te proberen.",
    "attendance.studentFallback": "Leerling #{{id}}",
    "attendance.verifyAttendanceFailed": "Aanwezigheid kon niet worden gecontroleerd. Afronden is geblokkeerd tot dit lukt — vernieuw en probeer opnieuw.",
    "attendance.walkInsLoadFailed": "Walk-in-studenten konden niet worden geladen. Vernieuw en probeer opnieuw.",
    "auth.accountDisabled": "Dit account is uitgeschakeld.",
    "auth.checkingSetup": "Academie-instellingen controleren...",
    "calendar.holidaysLoadFailed": "Feestdagen konden niet worden geladen. De agenda kan eruitzien als een normale werkweek.",
    "calendar.viewingOtherCoachNoHost": "Andere coach bekijken — open uw agenda om te hosten.",
    "charts.academyByBranch": "Bruto per vestiging",
    "charts.academyByBranchHint": "Vergelijk bruto-omzet per vestiging",
    "charts.academyMonthlyTrend": "Maandelijkse omzettrend",
    "charts.academyMonthlyTrendHint": "Bruto-, academie- en coachuitbetalingen per maand",
    "charts.academyRevenueSplit": "Inkomstenverdeling",
    "charts.academyRevenueSplitHint": "Uitbetaling academie vs coach",
    "charts.atRisk": "In gevaar",
    "charts.atRiskCount": "{{count}} studenten",
    "charts.atRiskRateHint": "Laagste percentages in de huidige lijst",
    "charts.atRiskShare": "Risicoaandeel",
    "charts.atRiskShareHint": "Percentage van de selectie dat aandacht nodig heeft",
    "charts.atRiskTiers": "Risiconiveaus",
    "charts.attendanceBuckets": "Aanwezigheidspercentageverdeling",
    "charts.attendanceBucketsHint": "Leerlingen per aanwezigheidspercentage",
    "charts.attendanceRates": "Aanwezigheidspercentages",
    "charts.attendanceSnapshot": "Aanwezigheidsoverzicht",
    "charts.attendanceWtd": "Aanwezigheid deze week",
    "charts.childAttendance": "Aanwezigheid kind",
    "charts.childRating": "Kindbeoordeling",
    "charts.coachGrossCompare": "Bruto per coach",
    "charts.coachGrossCompareHint": "Vergelijk bruto-inkomsten van coaches",
    "charts.coachRevenueTrend": "Inkomsten per dag",
    "charts.coachRevenueTrendHint": "Bruto-, academie- en coachinkomsten over de periode",
    "charts.commissionSplit": "Commissieverdeling",
    "charts.commissionSplitHint": "Aandeel academie vs coach",
    "charts.completedSessionsWeek": "Van voltooide sessies deze week",
    "charts.defaultSeries": "Waarde",
    "charts.gameRecord": "Spelrecord",
    "charts.healthy": "Gezond",
    "charts.hoursByWeekday": "Uren per weekdag",
    "charts.legend": "Legenda van het diagram",
    "charts.manageBranches": "Vestigingen",
    "charts.managerBranchHint": "Actieve studenten in uw vestigingen",
    "charts.noAtRiskData": "Er zijn nog geen risicogegevens om in kaart te brengen",
    "charts.noAttendanceBucketData": "Geen leerlingrijen om weer te geven",
    "charts.noAttendanceMarks": "Deze week zijn er nog geen aanwezigheidscijfers",
    "charts.noAttendanceYet": "Deze week nog geen voltooide sessies",
    "charts.noBranchAmountData": "Geen vestigingsbedragen om weer te geven",
    "charts.noBranchData": "Nog geen vestigingsinschrijvingsgegevens",
    "charts.noBranchEnrollmentYet": "Studenten zijn zichtbaar, maar er zijn nog geen studenten ingeschreven in uw vestigingen",
    "charts.noCoachData": "Geen coachuitsplitsing om weer te geven",
    "charts.noDataYet": "Er zijn nog geen gegevens om in kaart te brengen",
    "charts.noGamesYet": "Nog geen beoordeelde games",
    "charts.noHealthData": "Nog geen gegevens over de gezondheid van studenten",
    "charts.noHoursYet": "Deze week zijn er geen lesuren geregistreerd",
    "charts.noMonthlyData": "Geen maandelijkse uitsplitsing om weer te geven",
    "charts.noPlayingYet": "Nog geen speelactiviteit",
    "charts.noRecentMarks": "Geen recente aanwezigheidscijfers",
    "charts.noSlotData": "Geen aanwezigheidsslots om weer te geven",
    "charts.noSplitData": "Geen commissieverdeling om weer te geven",
    "charts.noStatementStatusData": "Geen afschriftstatus om in kaart te brengen",
    "charts.noStatusData": "Geen statusgroepen om weer te geven",
    "charts.noStudentsInYourBranches": "Er zijn nog geen ingeschreven studenten in jouw vestigingen",
    "charts.noTrendData": "Geen dagelijkse omzet om weer te geven",
    "charts.notEnrolled": "Niet ingeschreven",
    "charts.open": "Open",
    "charts.paymentsDueByBranch": "Verschuldigd bedrag per filiaal",
    "charts.paymentsDueByBranchHint": "Achterstallige bedragen verzameld per filiaal",
    "charts.paymentsDueStatus": "Betaalstatusmix",
    "charts.paymentsDueStatusHint": "Achterstallig, laag saldo en OK-leerlingen",
    "charts.playingPeek": "Speelactiviteit",
    "charts.presentVsAbsent": "Aanwezig versus afwezig",
    "charts.presentVsAbsentHint": "Totaal aantal aanwezigen in de periode",
    "charts.rate": "Tarief",
    "charts.recentMarks": "Recente cijfers",
    "charts.statementStatusMix": "Status van afschrift-e-mails",
    "charts.statementStatusMixHint": "Verzonden, in behandeling, mislukt en niet verzonden",
    "charts.studentHealth": "Leerlingstatus",
    "charts.studentHealthHint": "Risico versus gezond rooster",
    "charts.students": "Leerlingen",
    "charts.studentsByBranch": "Studenten per vestiging",
    "charts.studentsByBranchHint": "Ingeschreven studenten per vestiging (inclusief niet-ingeschrevenen)",
    "charts.tierCriticalShort": "Kritiek",
    "charts.tierHighShort": "Hoog",
    "charts.tierMediumShort": "Gemiddeld",
    "charts.unsolvedAttempts": "Andere pogingen",
    "charts.viewAtRisk": "Bekijk risicovol",
    "charts.viewHistory": "Geschiedenis",
    "charts.viewStudents": "Studenten",
    "charts.weekToDate": "Week tot nu toe",
    "classroom.live.notStartedHint": "Je coach is nog niet begonnen met deze online les.",
    "classroom.live.notStartedYet": "Nog niet begonnen",
    "classroom.meeting.admitAll": "Geef alles toe",
    "classroom.meeting.admitFailed": "Kon wachtende studenten niet toelaten.",
    "classroom.meeting.admitOne": "Toegeven",
    "classroom.meeting.admitting": "Toegeven…",
    "classroom.meeting.connectedHint": "Live via ChessDesk",
    "classroom.meeting.embedAuthMissing": "Vergaderingsgegevens niet beschikbaar. Controleer de Zoom Meeting SDK-gegevens onder Klaslokaal → Zoom.",
    "classroom.meeting.embedUnavailableRetry": "Video kon niet in de browser starten. Probeer opnieuw of gebruik Openen in Zoom-app.",
    "classroom.meeting.guest": "Gast",
    "classroom.meeting.hostZakMissing": "Hostgegevens ontbreken. Stel onder Klaslokaal → Instellingen het Zoom-host-e-mailadres in op een gelicentieerde Zoom-gebruiker en probeer opnieuw.",
    "classroom.meeting.notActuallyHost": "Deelgenomen, maar Zoom gaf geen hostrechten. Stel onder Klaslokaal → Instellingen het Zoom-host-e-mailadres in op uw gelicentieerde Zoom-login, verlaat en doe opnieuw mee als coach.",
    "classroom.meeting.scriptLoadFailed": "Zoom-script kon niet worden geladen: {{src}}",
    "classroom.meeting.sdkLoadFailed": "Zoom Meeting SDK kon niet worden geladen.",
    "classroom.meeting.waitingForHost": "Wacht tot uw coach de les start. Blijf op deze pagina — u komt binnen wanneer hij deelneemt.",
    "classroom.meeting.waitingGuest": "Gast",
    "classroom.meeting.waitingRoomTitle": "{{count}} leerling(en) in de wachtkamer",
    "classroom.meeting.zoomJoinFailed": "Zoom-deelname mislukt",
    "classroom.zoom.clientIdPlaceholder": "bijv. AbCdEfGh...",
    "classroom.zoom.meetingSdkHeading": "Ingesloten video (Meeting SDK)",
    "common.academyLogo": "Academie-logo",
    "common.backHome": "Terug naar huis",
    "common.currencyWord": "valuta",
    "common.guest": "Gast",
    "common.listLoadFailed": "Deze lijst kon niet worden geladen. Vernieuw en probeer opnieuw.",
    "common.noData": "Geen gebruikers gevonden.",
    "common.notSet": "niet ingesteld",
    "common.optional": "Optioneel",
    "common.optionsLoadFailed": "Opties konden niet worden geladen. Vernieuw de pagina of probeer opnieuw.",
    "common.pageNotFound": "Pagina niet gevonden",
    "common.pageNotFoundHint": "Deze link komt niet overeen met een pagina in de app. Controleer de URL of ga terug naar huis.",
    "common.period": "periode",
    "common.required": "Vereist",
    "common.retry": "Opnieuw proberen",
    "common.rowN": "Rij {{n}}",
    "common.unknownError": "Onbekende fout",
    "enrollments.activateFailed": "Deze inschrijving kon niet worden geactiveerd.",
    "enrollments.form.noStudentMatches": "Geen leerlingen komen overeen met uw zoekopdracht.",
    "enrollments.form.noStudentsAvailable": "Geen leerlingen beschikbaar om in te schrijven.",
    "enrollments.paymentModal.coachAskTopUp": "Vraag een manager of beheerder om de portemonnee van deze leerling op te waarderen en vernieuw daarna het saldo.",
    "enrollments.renewMissingData": "Kan niet verlengen — student-, niveau- of groepgegevens ontbreken.",
    "exports.batchId": "Batch-ID",
    "exports.batchName": "Batchnaam",
    "exports.branch": "Vestiging",
    "exports.branchId": "Vestiging-ID",
    "exports.code": "Code",
    "exports.email": "E-mail",
    "exports.id": "ID",
    "exports.level": "Niveau",
    "exports.levelId": "Niveau-ID",
    "exports.manager": "Manager",
    "exports.mode": "Modus",
    "exports.name": "Naam",
    "exports.phone": "Telefoon",
    "exports.roles": "Rollen",
    "exports.scope": "Domein",
    "exports.scopeBatch": "Batch #{{id}}",
    "exports.scopeBranch": "Filiaal #{{id}}",
    "exports.scopeGlobal": "Globaal",
    "exports.scopeLevel": "Niveau #{{id}}",
    "exports.sessionDays": "Sessiedagen",
    "exports.sheetGeneric": "Blad",
    "exports.sheetReport": "Rapport",
    "exports.status": "Status",
    "exports.userId": "Gebruikers-ID",
    "exports.username": "Gebruikersnaam",
    "exports.value": "Waarde",
    "forms.address.citiesLoadFailed": "Steden konden niet worden geladen — u kunt de plaatsnaam nog steeds typen.",
    "forms.batch.loadFailed": "Kan deze batch niet laden.",
    "forms.branch.loadFailed": "Kan deze vestiging niet laden.",
    "forms.common.back": "Rug",
    "forms.level.loadFailed": "Kan dit niveau niet laden.",
    "forms.student.eloPlaceholder": "bijv. 1650",
    "forms.student.fideIdPlaceholder": "bijv. 1503014",
    "forms.student.fideTitlePlaceholder": "bijv. CM, FM, IM, GM",
    "guardianPublic.registrationSubmitted": "Registratie ingediend. Meld u aan nadat uw academie de toegang als voogd heeft goedgekeurd.",
    "guardianPublic.requestSubmitted": "Aanvraag ingediend. Meld u aan nadat uw academie de toegang als voogd heeft goedgekeurd.",
    "levels.unnamed": "Niveau",
    "notificationBell.countUnknown": "Aantal ongelezen niet beschikbaar",
    "notificationBell.markReadFailed": "Kon niet als gelezen markeren. Probeer opnieuw.",
    "notifications.content.reviewGame": "Recensie spel",
    "notificationsPage.markAllFailed": "Alles als gelezen markeren mislukt. Probeer opnieuw.",
    "pages.adminDashboard.statsLoadFailed": "Dashboardstatistieken konden niet worden geladen. Onderstaande afbeeldingen zijn mogelijk onvolledig. Ververs de pagina om het opnieuw te proberen.",
    "pages.coaches.manageAssignments.coachLabel": "Coach: {{name}}",
    "pages.discountForm.codePlaceholder": "bijv. SIBLING_10, EARLY_BIRD",
    "pages.discountForm.flatValuePlaceholder": "bijv. 500",
    "pages.discountForm.namePlaceholder": "bijv. Broer/zus-korting, Early bird",
    "pages.discountForm.percentValuePlaceholder": "bijv. 10",
    "pages.enrollmentDetail.afterDiscountApplied": "Na {{value}} korting",
    "pages.enrollmentDetail.batchLoadFailed": "Batchgegevens konden niet worden geladen. Kosten- en periode-info kan onvolledig zijn.",
    "pages.enrollmentDetail.receivers.OTHERS": "Overige",
    "pages.enrollmentDetail.receivers.USER": "Student / gezin",
    "pages.enrollmentDetail.types.REGULAR": "Regulier",
    "pages.enrollmentDetail.types.SINGLE_SESSION": "Enkele sessie",
    "pages.feePlanForm.groupTypes.GROUP": "Groep",
    "pages.feePlanForm.groupTypes.ONE_TO_ONE": "Individueel",
    "pages.feePlanForm.planTypes.MONTHLY": "Maandelijks",
    "pages.feePlanForm.planTypes.PACKAGE": "Pakket",
    "pages.feePlanForm.planTypes.PER_SESSION": "Per sessie",
    "pages.managerDashboard.statsLoadFailed": "Dashboardstatistieken konden niet worden geladen. Onderstaande afbeeldingen zijn mogelijk onvolledig. Ververs de pagina om het opnieuw te proberen.",
    "pages.notifications.classroomStarted": "Meldingen bij start van live les",
    "pages.parentHome.childPlayingLive": "Speel nu live",
    "pages.parentHome.noPlayingYet": "Er zijn nog geen platformgames voor dit kind.",
    "pages.parentHome.partialSnapshot": "Sommige kindoverzichtsgegevens konden niet worden geladen. Cijfers kunnen onvolledig zijn — vernieuw om opnieuw te proberen.",
    "pages.parentHome.playingLoadFailed": "Kan activiteit op het speelplatform niet laden.",
    "pages.parentHome.playingPlatform": "Speelplatform",
    "pages.parentHome.snapshotLoadFailed": "Kindoverzicht kon niet worden geladen. Vernieuw om opnieuw te proberen.",
    "pages.parentHome.viewPlayProfile": "Bekijk speelprofiel",
    "pages.parentHome.watchLive": "Kijk live",
    "pages.sessionStatement.transactionsCount": "{{count}} transacties",
    "pages.studentBulkImport.cols.addressLine1": "Adres, appartement/huisnummer",
    "pages.studentBulkImport.cols.addressLine2": "Aanvullende adresinformatie — oriëntatiepunt, gebied, enz.",
    "pages.studentBulkImport.cols.city": "Stad",
    "pages.studentBulkImport.cols.country": "Land",
    "pages.studentBulkImport.cols.dob": "Geboortedatum in regionaal academieformaat ({{format}}) of JJJJ-MM-DD",
    "pages.studentBulkImport.cols.email": "Geldig e-mailadres: moet uniek zijn",
    "pages.studentBulkImport.cols.firstName": "Unicode-letters toegestaan ​​(bijv. François, Müller)",
    "pages.studentBulkImport.cols.gender": "MANNELIJK | VROUW | ANDERE (hoofdletters)",
    "pages.studentBulkImport.cols.lastName": "Unicode-letters toegestaan ​​(bijv. Dupont, van der Berg)",
    "pages.studentBulkImport.cols.middleName": "Optioneel — accenten, spaties, koppeltekens, apostrofs OK",
    "pages.studentBulkImport.cols.password": "Optioneel: overschrijft het standaardwachtwoord voor deze rij",
    "pages.studentBulkImport.cols.phoneNumber": "Lokaal nummer of volledig internationaal (+…). Lokale nummers gebruiken het academieland uit Regionale instellingen.",
    "pages.studentBulkImport.cols.pincode": "Pincode/postcode",
    "pages.studentBulkImport.cols.state": "Staat/provincie",
    "pages.studentBulkImport.cols.username": "Unieke login-gebruikersnaam (bijv. rahul.sharma)",
    "pages.studentBulkImport.csvGuide": "CSV-formaatgids",
    "pages.studentBulkImport.duplicateSkipped": "Overgeslagen — student met deze gebruikersnaam of e-mail bestaat al",
    "pages.studentBulkImport.processingRow": "Rij {{current}} van {{total}} — {{name}}",
    "pages.studentBulkImport.unknownError": "Onbekende fout",
    "pages.studentBulkImport.validation.dobFormat": "dob moet {{format}} of JJJJ-MM-DD zijn",
    "pages.studentBulkImport.validation.dobInvalid": "dob is geen geldige datum",
    "pages.studentBulkImport.validation.emailInvalid": "e-mailadres \"{{value}}\" is niet geldig",
    "pages.studentBulkImport.validation.genderInvalid": "geslacht \"{{value}}\" is ongeldig: moet MANNELIJK, VROUWELIJK of ANDERS zijn",
    "pages.studentBulkImport.validation.genderRequired": "geslacht is vereist (MANNELIJK / VROUWELIJK / ANDERS)",
    "pages.studentBulkImport.validation.invalidName": "{{field}} moet een geldige naam zijn (letters, spaties, koppeltekens, apostrofs; accenten toegestaan)",
    "pages.studentBulkImport.validation.phoneInvalid": "telefoonnummer is niet geldig",
    "pages.studentBulkImport.validation.required": "{{field}} is vereist",
    "pages.studentDashboard.partialLoad": "Sommige dashboardgegevens kunnen niet worden geladen. De cijfers zijn mogelijk onvolledig. Ververs de pagina om het opnieuw te proberen.",
    "pages.userDetails.genderFemale": "Vrouw",
    "pages.userDetails.genderMale": "Man",
    "pages.userDetails.genderOther": "Anders",
    "pages.wallet.gatewaysLoadFailed": "Online betaalopties konden niet worden gecontroleerd. Vernieuw en probeer opnieuw.",
    "pages.wallet.methodCash": "Contant",
    "pages.wallet.methodsLoadFailed": "Betaalmethoden konden niet worden geladen. De lijst met modi is mogelijk onvolledig.",
    "pages.wallet.unsupportedGateway": "Niet-ondersteund antwoord van de betaalgateway.",
    "pages.walletTopup.noManagedStudents": "Nog geen leerlingen in uw beheerde vestigingen. Voeg eerst leerlingen toe of schrijf ze in.",
    "pages.walletTopup.staffLoadFailed": "Personeelslijst kon niet worden geladen. Vernieuw en probeer opnieuw.",
    "pages.walletTopup.studentsLoadFailed": "Studenten konden niet worden geladen. Vernieuw en probeer opnieuw.",
    "parent.childrenLoadFailed": "Kan gekoppelde studenten niet laden",
    "parent.childrenLoadFailedHint": "Dit is niet hetzelfde als geen kinderen hebben. Vernieuw om het opnieuw te proberen.",
    "phone.digitsRequired": "Telefoonnummer moet cijfers bevatten.",
    "phone.required": "Telefoonnummer is vereist.",
    "playing.academyStudents": "Academie studenten",
    "playing.assignPractice": "Huiswerk",
    "playing.assignSelectedPack": "Geselecteerde toewijzen",
    "playing.assignToStudent": "Toewijzen aan",
    "playing.backToHub": "Terug naar de hub",
    "playing.checkIn": "Inchecken",
    "playing.checkInFailed": "Kan het inchecken niet updaten.",
    "playing.checkedIn": "In",
    "playing.checkedInCount": "{{checked}}/{{total}} ingecheckt",
    "playing.coachBoardShortcut": "Lesbord + Klaslokaal",
    "playing.coachDebriefBoards": "Coachdebriefing - alle borden",
    "playing.coachDesk": "Bureau",
    "playing.coachRosterPicker": "Student op rooster",
    "playing.coachRosterPickerMe": "Mijn eigen spellen",
    "playing.confirmMoveAction": "Speel beweging",
    "playing.copyStandings": "Kopieer klassement",
    "playing.copyStudyPgn": "Kopieer geannoteerde PGN",
    "playing.copyTeachingLink": "Kopieer de leslink",
    "playing.createAndOpen": "Maken en openen",
    "playing.createBan": "Speler verbieden",
    "playing.createDraft": "Concept opslaan",
    "playing.defaultTeamA": "Ploeg A",
    "playing.defaultTeamB": "Ploeg B",
    "playing.dismissPack": "Pakket afwijzen",
    "playing.draftFromMistakes": "Conceptpakket uit het spel",
    "playing.draws": "Trekt",
    "playing.fairnessTeachingHint": "{{n}} zetten gemarkeerd (hoogste: {{level}}). Gebruik voor lesgeven — open fair play indien nodig.",
    "playing.friendlyRematch": "Vriendschappelijke herkansing",
    "playing.friendlyRematchHint": "Buiten het evenement · informeel (niet beoordeeld)",
    "playing.gameType.VS_COMPUTER": "tegen computer",
    "playing.increment": "Bijtelling (sec)",
    "playing.liftBan": "Liftverbod",
    "playing.livePeekLoadFailed": "Kan live games momenteel niet laden.",
    "playing.loadRecentGame": "Laad een recent spel",
    "playing.loadRecentGamePlaceholder": "Kies een voltooid spel...",
    "playing.losses": "Verliezen",
    "playing.matchmakingPausedShort": "Matchmaking onderbroken. Probeer de bancontrole opnieuw",
    "playing.material": "Materiaal",
    "playing.mistakeCount": "{{n}} fouten",
    "playing.noRecentGamesToLoad": "Er zijn nog geen voltooide games om te laden. Plak een PGN of stel hieronder een FEN in.",
    "playing.nudgeSent": "Herinnering verzonden.",
    "playing.openCoachBoard": "Open op coachbord",
    "playing.openFairPlay": "Fairplay-recensie openen",
    "playing.openForRegistration": "Open voor registratie",
    "playing.openRegistrationNow": "Open nu de inschrijving (anders opslaan als concept)",
    "playing.openings.benoni_benko_path": "Benoni- / Benko-pad",
    "playing.openings.birds_opening": "Bird-opening",
    "playing.openings.caro_kann_advance": "Caro-Kann — Opstoot",
    "playing.openings.caro_kann_classical": "Caro-Kann — Klassiek",
    "playing.openings.dutch_defence": "Hollandse verdediging",
    "playing.openings.english_1_e5": "Engels — 1…e5",
    "playing.openings.english_1_e6": "Engels — 1…e6",
    "playing.openings.english_anglo_indian": "Engels — Anglo-Indiaas",
    "playing.openings.english_opening": "Engelse opening",
    "playing.openings.english_symmetrical": "Engels — Symmetrisch",
    "playing.openings.french_advance": "Frans — Opstoot",
    "playing.openings.french_classical": "Frans — Klassiek",
    "playing.openings.french_exchange": "Frans — Ruil",
    "playing.openings.giuoco_piano_open": "Giuoco Piano — open partij",
    "playing.openings.indian_defence": "Indische verdediging",
    "playing.openings.kings_indian_defence": "Konings-Indische verdediging",
    "playing.openings.kings_knight_two_knights_path": "Koningspaard — Tweepaardpad",
    "playing.openings.london_system_main_line": "Londens systeem — hoofdlijn",
    "playing.openings.nimzo_indian_defence": "Nimzo-Indisch",
    "playing.openings.nimzo_indian_path": "Nimzo-Indisch pad",
    "playing.openings.nimzo_larsen_attack": "Nimzo-Larsen-aanval",
    "playing.openings.queens_gambit_accepted": "Aangenomen damegambiet",
    "playing.openings.queens_gambit_declined_london_hybrid": "Afgewezen damegambiet — London-hybride",
    "playing.openings.queens_indian_nimzo_path": "Dame-Indisch / Nimzo-pad",
    "playing.openings.r_ti_opening": "Réti-opening",
    "playing.openings.ruy_lopez_morphy_closed": "Spaans — Morphy, gesloten",
    "playing.openings.ruy_lopez_morphy_defence": "Spaans — Morphy-verdediging",
    "playing.openings.scandinavian_2_nf6": "Scandinavisch — 2…Pf6",
    "playing.openings.scandinavian_2_qxd5": "Scandinavisch — 2…Dxd5",
    "playing.openings.sicilian_2_d6": "Siciliaans — 2…d6",
    "playing.openings.sicilian_2_e6": "Siciliaans — 2…e6",
    "playing.openings.sicilian_2_nc6": "Siciliaans — 2…Pc6",
    "playing.openings.sicilian_2_nf3": "Siciliaans — 2.Pf3",
    "playing.openings.sicilian_classical_path": "Siciliaans — klassiek pad",
    "playing.openings.sicilian_dragon": "Siciliaans — Draak",
    "playing.openings.sicilian_dragon_classical": "Siciliaans — Draak, klassiek",
    "playing.openings.sicilian_dragon_yugoslav": "Siciliaans — Draak, Joegoslavisch",
    "playing.openings.sicilian_hyperaccelerated": "Siciliaans — Hyperversneld",
    "playing.openings.sicilian_najdorf": "Siciliaans — Najdorf",
    "playing.openings.sicilian_najdorf_english_attack": "Siciliaans — Najdorf, Engelse aanval",
    "playing.openings.slav_defence": "Slavische verdediging",
    "playing.openings.van_geet_opening": "Van Geet-opening",
    "playing.packAssignEmpty": "Selecteer puzzels en leerlingen om toe te wijzen.",
    "playing.packAssigned": "Toegewezen {{n}} huiswerkpuzzels.",
    "playing.parentChallengeBlockedHint": "Ouders kunnen tegen de computer spelen en naar hun kinderen kijken – menselijke uitdagingen zijn voor spelers.",
    "playing.parentChallengeBlockedTitle": "Uitdagingen zijn voor spelers",
    "playing.parentChallengeHint": "Uitdagingen worden verzonden vanuit het account van uw kind, niet dat van u.",
    "playing.parentChallengeToastHint": "Ouders spelen geen menselijke spelletjes. Weiger deze uitnodiging of speel tegen de computer via de hub.",
    "playing.pgn.clubGame": "Clubpartij",
    "playing.pickTeam": "Kies een team",
    "playing.playersCount": "{{n}} spelers",
    "playing.privateGame": "Privé",
    "playing.privateLinkHint": "Deze partij is privé — de gekopieerde link werkt alleen voor de twee spelers (en medewerkers).",
    "playing.profile": "Profiel",
    "playing.quality.best": "Beste",
    "playing.quality.blunder": "Blunder",
    "playing.quality.brilliant": "Briljant",
    "playing.quality.good": "Goed",
    "playing.quality.inaccuracy": "Onnauwkeurigheid",
    "playing.quality.mistake": "Fout",
    "playing.recentGamesLoadFailed": "Kan recente games voor de kiezer niet laden.",
    "playing.rematchNightHint": "Vriendelijke (niet-geclassificeerde) uitdagingen buiten het evenement",
    "playing.rematchNightOpponents": "Rematch night tegenstanders",
    "playing.removePlayer": "Verwijderen",
    "playing.removePlayerConfirm": "{{name}} verwijderen van deze clubavond?",
    "playing.removePlayerFailed": "Kan speler niet verwijderen.",
    "playing.reviewReadyStrip": "Beoordeling klaar",
    "playing.saveDue": "Inleverdatum opslaan",
    "playing.saveFailed": "Kan niet opslaan.",
    "playing.scrubToMistake": "Scrub een fout met de beste zet om één laag te redden.",
    "playing.selectStudent": "Selecteer leerling…",
    "playing.solved": "Opgelost",
    "playing.speed.BLITZ": "Blitz",
    "playing.speed.BULLET": "Bullet",
    "playing.speed.CLASSICAL": "Klassiek",
    "playing.speed.CORRESPONDENCE": "Correspondentie",
    "playing.speed.RAPID": "Rapid",
    "playing.startingNow": "Vanaf nu",
    "playing.startsAt": "Begint om",
    "playing.startsIn": "Begint over {{when}}",
    "playing.stockfish.disabled": "Schaakengine-analyse is uitgeschakeld op deze server.",
    "playing.stockfish.notStarted": "De schaakengine is nog niet gereed.",
    "playing.stockfish.unavailable": "Schaakengine-analyse is momenteel niet beschikbaar.",
    "playing.studyMistakes": "Studie fouten",
    "playing.studyOnCoachBoard": "Studie",
    "playing.studyPgnCopied": "Geannoteerde PGN gekopieerd",
    "playing.studySource": "Studie bron",
    "playing.suggestedBlunderer": "voorgesteld",
    "playing.teachingLinkCopied": "Leslink gekopieerd",
    "playing.teamA": "Naam ploeg A",
    "playing.teamB": "Naam ploeg B",
    "playing.teamBattleNoTeamsYet": "Teams zijn nog niet ingesteld. Vraag het personeel om teams toe te voegen voordat u lid wordt.",
    "playing.undoCheckIn": "Ongedaan maken",
    "playing.viewAllYourMoves": "Bekijk al je bewegingen",
    "playing.waitingForOpponentDraw": "Wachten op tegenstander...",
    "playing.waitingForOpponentTakeback": "Wachten op tegenstander...",
    "playing.wins": "wint",
    "playing.yourMoveMoreHint": "Er wachten nog meer games op je",
    "playing.yourMoveStrip": "Jouw zet",
    "playing.yourResult": "Jouw resultaat",
    "playing.yourResultPlace": "#{{place}} · {{score}} punten",
    "reports.common.batchSession": "Partij",
    "reports.common.records": "{{count}} rijen",
    "reports.common.selectLevelFirst": "Selecteer eerst een niveau om op batch te filteren",
    "reports.dataExport.downloadPlaying": "playing-games.csv downloaden",
    "reports.dataExport.exportPlayingFailed": "Export van speelplatform mislukt.",
    "reports.dataExport.playingGames": "Speelplatform-partijen",
    "reports.dataExport.playingGamesDesc": "Schaakpartijen (PGN, resultaat, klokken) voor de geselecteerde student — voor DSAR-/portabiliteitspakketten.",
    "reports.dataExport.playingStudentRequired": "Kies een leerling om speelplatform-partijen te exporteren.",
    "reports.paymentsDue.statusOk": "OK",
    "reports.settingsLoadFailed": "Kan rapportinstellingen niet laden",
    "reports.settingsLoadFailedHint": "Rapportinstellingen konden niet worden vernieuwd. De beschikbaarheid hieronder kan verouderd zijn.",
    "sessions.verifyAttendanceFailed": "Aanwezigheid kon niet worden gecontroleerd. Afronden is geblokkeerd tot dit lukt — vernieuw en probeer opnieuw.",
    "settings.email.testCompleted": "Test voltooid. Aflevering kon niet volledig worden geverifieerd — controleer spam/promoties.",
    "settings.email.testSmtpOnly": "SMTP heeft het bericht geaccepteerd, maar de bezorging is niet volledig geverifieerd.",
    "settings.email.testVerifiedSent": "Bevestigd: bericht geaccepteerd door SMTP en gevonden in Verzonden ({{seconds}}s). Vraag de ontvanger inbox en spam te controleren.",
    "settings.holidays.emailPreview.roles.Other": "Overig",
    "settings.notifications.channelStatusLoadFailed": "Kan status van WhatsApp/e-mailkanaal niet vernieuwen. De beschikbaarheid van de schakelaar is mogelijk verouderd. Vernieuw de pagina.",
    "settings.notifications.loadFailed": "Kan meldingsvoorkeuren niet laden.",
    "settings.payment.eventStatus.FAILED": "Mislukt",
    "settings.payment.eventStatus.PENDING": "In behandeling",
    "settings.payment.eventStatus.SUCCESS": "Geslaagd",
    "settings.payment.gateways.mollie.keyIdLabel": "Mollie-profiel-ID (optioneel)",
    "settings.payment.gateways.mollie.keyIdPlaceholder": "pfl_… of leeg laten",
    "settings.payment.gateways.mollie.keySecretLabel": "Mollie API-sleutel",
    "settings.payment.gateways.mollie.keySecretPlaceholder": "test_… of live_…",
    "settings.payment.gateways.mollie.subtitle": "iDEAL · Bancontact · Kaarten · SEPA (Europa)",
    "settings.payment.gateways.mollie.webhookLabel": "Niet gebruikt (Mollie verifieert via API-ophaal)",
    "settings.payment.gateways.mollie.webhookPlaceholder": "",
    "settings.payment.gateways.paypal.keyIdLabel": "PayPal-client-ID",
    "settings.payment.gateways.paypal.keyIdPlaceholder": "Client-ID van developer.paypal.com",
    "settings.payment.gateways.paypal.keySecretLabel": "PayPal-clientgeheim",
    "settings.payment.gateways.paypal.keySecretPlaceholder": "Clientgeheim",
    "settings.payment.gateways.paypal.subtitle": "PayPal-saldo · Kaarten",
    "settings.payment.gateways.paypal.webhookLabel": "PayPal-webhook-ID",
    "settings.payment.gateways.paypal.webhookPlaceholder": "Webhook-ID van developer.paypal.com",
    "settings.payment.gateways.razorpay.keyIdLabel": "Razorpay-sleutel-ID",
    "settings.payment.gateways.razorpay.keyIdPlaceholder": "rzp_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.razorpay.keySecretLabel": "Razorpay-geheime sleutel",
    "settings.payment.gateways.razorpay.keySecretPlaceholder": "Razorpay-geheime sleutel",
    "settings.payment.gateways.razorpay.subtitle": "UPI · Kaarten · internetbankieren · portemonnees",
    "settings.payment.gateways.razorpay.webhookLabel": "Razorpay-webhookgeheim (optionele back-up)",
    "settings.payment.gateways.razorpay.webhookPlaceholder": "Van Razorpay Dashboard → Webhooks",
    "settings.payment.gateways.stripe.keyIdLabel": "Stripe publiceerbare sleutel",
    "settings.payment.gateways.stripe.keyIdPlaceholder": "pk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.keySecretLabel": "Stripe geheime sleutel",
    "settings.payment.gateways.stripe.keySecretPlaceholder": "sk_live_xxxxxxxxxxxxxxxx",
    "settings.payment.gateways.stripe.subtitle": "Kaarten · Apple Pay · Google Pay · lokale methoden",
    "settings.payment.gateways.stripe.webhookLabel": "Stripe-webhook-ondertekeningsgeheim",
    "settings.payment.gateways.stripe.webhookPlaceholder": "whsec_xxxxxxxxxxxxxxxx",
    "settings.whatsapp.messageTypes.ABSENCE_ALERT_STUDENT": "Afwezigheidsmelding (leerling)",
    "settings.whatsapp.messageTypes.CLASSROOM_STARTED_STUDENT": "Les gestart (leerling)",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_DEADLINE_REMINDER": "Correspondentie-deadlineherinnering",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_YOUR_MOVE": "Correspondentie — jouw zet",
    "settings.whatsapp.messageTypes.FEE_REMINDER_STUDENT": "Betalingsherinnering (leerling)",
    "settings.whatsapp.messageTypes.HOLIDAY_ANNOUNCEMENT": "Vakantieaankondiging",
    "settings.whatsapp.messageTypes.LOW_BALANCE_ADMIN": "Laag saldo (beheerder)",
    "settings.whatsapp.messageTypes.LOW_BALANCE_STUDENT": "Laag saldo (leerling)",
    "settings.whatsapp.messageTypes.PENDING_SESSIONS_COACH": "Openstaande sessies (coach)",
    "settings.whatsapp.messageTypes.SESSION_CANCELLED_STUDENT": "Sessie geannuleerd (leerling)",
    "settings.whatsapp.messageTypes.SESSION_REMINDER_STUDENT": "Sessieherinnering (leerling)",
    "settings.whatsapp.msgStatus.FAILED": "Mislukt",
    "settings.whatsapp.msgStatus.PENDING": "In behandeling",
    "settings.whatsapp.msgStatus.PROCESSING": "Bezig",
    "settings.whatsapp.msgStatus.QUEUED": "In wachtrij",
    "settings.whatsapp.msgStatus.SENT": "Verzonden",
    "settings.whatsapp.queueStatus.FAILED": "Mislukt",
    "settings.whatsapp.queueStatus.PENDING": "In behandeling",
    "settings.whatsapp.queueStatus.PROCESSING": "Bezig",
    "settings.whatsapp.queueStatus.QUEUED": "In wachtrij",
    "settings.whatsapp.queueStatus.SENT": "Verzonden",
    "wallet.txnReasons.unknown": "{{reason}}",
    "walletStaff.credit": "Bijschrijving",
    "walletStaff.debit": "Afschrijving",
    "walletStaff.paymentMethodsLoadFailed": "Betaalmethoden konden niet worden geladen — fallbackoptie wordt gebruikt.",
    "walletStaff.refundConfirm": "{{amount}} van deze portemonnee terugbetalen? Dit kan hier niet ongedaan worden gemaakt."
  },
  "en": {
    "attendance.coachFallback": "Coach #{{id}}",
    "attendance.partialDetailsHint": "Some attendance details could not be fully loaded. Roster may be incomplete — refresh to try again.",
    "attendance.sessionDetailsLoadFailed": "Could not load session details. Roster may still work; refresh to retry.",
    "attendance.studentFallback": "Student #{{id}}",
    "attendance.verifyAttendanceFailed": "Could not verify attendance. Complete is blocked until this succeeds — refresh and try again.",
    "auth.accountDisabled": "This account has been disabled.",
    "auth.checkingSetup": "Checking academy setup…",
    "calendar.holidaysLoadFailed": "Holidays could not be loaded. The calendar may look like a normal work week.",
    "calendar.viewingOtherCoachNoHost": "Viewing another coach — open your calendar to host.",
    "charts.academyByBranch": "Gross by branch",
    "charts.academyByBranchHint": "Compare branch gross revenue",
    "charts.academyMonthlyTrend": "Monthly revenue trend",
    "charts.academyMonthlyTrendHint": "Gross, academy, and coach payouts by month",
    "charts.academyRevenueSplit": "Revenue split",
    "charts.academyRevenueSplitHint": "Academy vs coach payout",
    "charts.atRisk": "At risk",
    "charts.atRiskCount": "{{count}} students",
    "charts.atRiskRateHint": "Lowest rates in the current list",
    "charts.atRiskShare": "At-risk share",
    "charts.atRiskShareHint": "Percent of roster needing attention",
    "charts.atRiskTiers": "Risk tiers",
    "charts.attendanceBuckets": "Attendance % distribution",
    "charts.attendanceBucketsHint": "Students by attendance rate bucket",
    "charts.attendanceRates": "Attendance rates",
    "charts.attendanceSnapshot": "Attendance snapshot",
    "charts.attendanceWtd": "Attendance this week",
    "charts.childAttendance": "Child attendance",
    "charts.childRating": "Child rating",
    "charts.coachGrossCompare": "Gross by coach",
    "charts.coachGrossCompareHint": "Compare coach gross revenue",
    "charts.coachRevenueTrend": "Revenue by day",
    "charts.coachRevenueTrendHint": "Gross, academy, and coach earnings over the period",
    "charts.commissionSplit": "Commission split",
    "charts.commissionSplitHint": "Academy vs coach share",
    "charts.completedSessionsWeek": "From completed sessions this week",
    "charts.defaultSeries": "Value",
    "charts.gameRecord": "Game record",
    "charts.healthy": "Healthy",
    "charts.hoursByWeekday": "Hours by weekday",
    "charts.legend": "Chart legend",
    "charts.manageBranches": "Branches",
    "charts.managerBranchHint": "Active students across your branches",
    "charts.noAtRiskData": "No at-risk data to chart yet",
    "charts.noAttendanceBucketData": "No student rows to chart",
    "charts.noAttendanceMarks": "No attendance marks yet this week",
    "charts.noAttendanceYet": "No completed sessions this week yet",
    "charts.noBranchAmountData": "No branch amounts to chart",
    "charts.noBranchData": "No branch enrollment data yet",
    "charts.noBranchEnrollmentYet": "Students are visible but none are enrolled in your branches yet",
    "charts.noCoachData": "No coach breakdown to chart",
    "charts.noDataYet": "No data to chart yet",
    "charts.noGamesYet": "No rated games yet",
    "charts.noHealthData": "No student health data yet",
    "charts.noHoursYet": "No teaching hours logged this week",
    "charts.noMonthlyData": "No monthly breakdown to chart",
    "charts.noPlayingYet": "No playing activity yet",
    "charts.noRecentMarks": "No recent attendance marks",
    "charts.noSlotData": "No attendance slots to chart",
    "charts.noSplitData": "No commission split to chart",
    "charts.noStatementStatusData": "No statement status to chart",
    "charts.noStatusData": "No status buckets to chart",
    "charts.noStudentsInYourBranches": "No enrolled students in your branches yet",
    "charts.noTrendData": "No daily revenue to chart",
    "charts.notEnrolled": "Not enrolled",
    "charts.open": "Open",
    "charts.paymentsDueByBranch": "Amount due by branch",
    "charts.paymentsDueByBranchHint": "Overdue amounts aggregated by branch",
    "charts.paymentsDueStatus": "Payment status mix",
    "charts.paymentsDueStatusHint": "Overdue, low balance, and OK students",
    "charts.playingPeek": "Playing activity",
    "charts.presentVsAbsent": "Present vs absent",
    "charts.presentVsAbsentHint": "Total attendance slots in period",
    "charts.rate": "Rate",
    "charts.recentMarks": "Recent marks",
    "charts.statementStatusMix": "Statement email status",
    "charts.statementStatusMixHint": "Sent, pending, failed, and not sent",
    "charts.studentHealth": "Student health",
    "charts.studentHealthHint": "At-risk vs healthy roster",
    "charts.students": "Students",
    "charts.studentsByBranch": "Students by branch",
    "charts.studentsByBranchHint": "Enrolled students per branch (includes not enrolled)",
    "charts.tierCriticalShort": "Critical",
    "charts.tierHighShort": "High",
    "charts.tierMediumShort": "Medium",
    "charts.unsolvedAttempts": "Other attempts",
    "charts.viewAtRisk": "View at-risk",
    "charts.viewHistory": "History",
    "charts.viewStudents": "Students",
    "charts.weekToDate": "Week to date",
    "classroom.live.notStartedHint": "Your coach has not started this online class yet.",
    "classroom.live.notStartedYet": "Not started yet",
    "classroom.meeting.admitAll": "Admit all",
    "classroom.meeting.admitFailed": "Could not admit waiting students.",
    "classroom.meeting.admitOne": "Admit",
    "classroom.meeting.admitting": "Admitting…",
    "classroom.meeting.connectedHint": "Live in ChessDesk",
    "classroom.meeting.embedAuthMissing": "Meeting credentials unavailable. Check Zoom Meeting SDK credentials under Classroom → Zoom.",
    "classroom.meeting.guest": "Guest",
    "classroom.meeting.hostZakMissing": "Host credentials missing. Set Classroom → Settings → Zoom host user email to a licensed Zoom user, then try again.",
    "classroom.meeting.notActuallyHost": "Joined, but Zoom did not grant host. Set Classroom → Settings → Zoom host user email to your licensed Zoom login, Leave, and Join again as coach.",
    "classroom.meeting.scriptLoadFailed": "Failed to load Zoom script: {{src}}",
    "classroom.meeting.sdkLoadFailed": "Zoom Meeting SDK failed to load.",
    "classroom.meeting.waitingGuest": "Guest",
    "classroom.meeting.waitingRoomTitle": "{{count}} student(s) in the waiting room",
    "classroom.meeting.zoomJoinFailed": "Zoom join failed",
    "classroom.zoom.clientIdPlaceholder": "e.g. AbCdEfGh...",
    "common.academyLogo": "Academy logo",
    "common.backHome": "Back to home",
    "common.currencyWord": "currency",
    "common.guest": "Guest",
    "common.noData": "No users found.",
    "common.notSet": "not set",
    "common.optional": "Optional",
    "common.pageNotFound": "Page not found",
    "common.pageNotFoundHint": "This link does not match a page in the app. Check the URL or go back home.",
    "common.period": "period",
    "common.required": "Required",
    "common.rowN": "Row {{n}}",
    "enrollments.form.noStudentMatches": "No students match your search.",
    "enrollments.form.noStudentsAvailable": "No students available to enroll.",
    "enrollments.paymentModal.coachAskTopUp": "Ask a manager or admin to top up this student’s wallet, then refresh the balance.",
    "exports.batchId": "Batch ID",
    "exports.batchName": "Batch Name",
    "exports.branch": "Branch",
    "exports.branchId": "Branch ID",
    "exports.code": "Code",
    "exports.email": "Email",
    "exports.id": "ID",
    "exports.level": "Level",
    "exports.levelId": "Level ID",
    "exports.manager": "Manager",
    "exports.mode": "Mode",
    "exports.name": "Name",
    "exports.phone": "Phone",
    "exports.roles": "Roles",
    "exports.scope": "Scope",
    "exports.scopeBatch": "Batch #{{id}}",
    "exports.scopeBranch": "Branch #{{id}}",
    "exports.scopeGlobal": "Global",
    "exports.scopeLevel": "Stufe #{{id}}",
    "exports.sessionDays": "Session Days",
    "exports.sheetGeneric": "Sheet",
    "exports.sheetReport": "Report",
    "exports.status": "Status",
    "exports.userId": "User ID",
    "exports.username": "Username",
    "exports.value": "Value",
    "forms.batch.loadFailed": "Could not load this batch.",
    "forms.branch.loadFailed": "Could not load this branch.",
    "forms.common.back": "Back",
    "forms.level.loadFailed": "Could not load this level.",
    "forms.student.eloPlaceholder": "e.g. 1650",
    "forms.student.fideIdPlaceholder": "e.g. 1503014",
    "forms.student.fideTitlePlaceholder": "e.g. CM, FM, IM, GM",
    "levels.unnamed": "Level",
    "notificationBell.countUnknown": "Unread count unavailable",
    "notifications.content.reviewGame": "Review game",
    "notificationsPage.markAllFailed": "Could not mark all as read. Try again.",
    "pages.adminDashboard.statsLoadFailed": "Dashboard stats could not be loaded. Figures below may be incomplete — refresh to try again.",
    "pages.enrollmentDetail.batchLoadFailed": "Batch details could not be loaded. Charges and period info may be incomplete.",
    "pages.enrollmentDetail.receivers.OTHERS": "Others",
    "pages.enrollmentDetail.receivers.USER": "Student / family",
    "pages.enrollmentDetail.types.REGULAR": "Regular",
    "pages.enrollmentDetail.types.SINGLE_SESSION": "Single session",
    "pages.managerDashboard.statsLoadFailed": "Dashboard stats could not be loaded. Figures below may be incomplete — refresh to try again.",
    "pages.parentHome.childPlayingLive": "Playing live now",
    "pages.parentHome.noPlayingYet": "No Playing Platform games yet for this child.",
    "pages.parentHome.partialSnapshot": "Some child snapshot data could not be loaded. Figures may be incomplete — refresh to try again.",
    "pages.parentHome.playingLoadFailed": "Could not load Playing Platform activity.",
    "pages.parentHome.playingPlatform": "Playing Platform",
    "pages.parentHome.viewPlayProfile": "View play profile",
    "pages.parentHome.watchLive": "Watch live",
    "pages.sessionStatement.transactionsCount": "{{count}} transactions",
    "pages.studentBulkImport.cols.addressLine1": "Street address, flat / house number",
    "pages.studentBulkImport.cols.addressLine2": "Additional address info — landmark, area, etc.",
    "pages.studentBulkImport.cols.city": "City",
    "pages.studentBulkImport.cols.country": "Country",
    "pages.studentBulkImport.cols.dob": "Date of birth in academy regional format ({{format}}) or YYYY-MM-DD",
    "pages.studentBulkImport.cols.email": "Valid email address — must be unique",
    "pages.studentBulkImport.cols.firstName": "Unicode letters allowed (e.g. François, Müller)",
    "pages.studentBulkImport.cols.gender": "MALE | FEMALE | OTHER (uppercase)",
    "pages.studentBulkImport.cols.lastName": "Unicode letters allowed (e.g. Dupont, van der Berg)",
    "pages.studentBulkImport.cols.middleName": "Optional — accents, spaces, hyphens, apostrophes OK",
    "pages.studentBulkImport.cols.password": "Optional — overrides default password for this row",
    "pages.studentBulkImport.cols.phoneNumber": "Local number or full international (+…). Local numbers use academy country from Regional Settings.",
    "pages.studentBulkImport.cols.pincode": "PIN / ZIP code",
    "pages.studentBulkImport.cols.state": "State / province",
    "pages.studentBulkImport.cols.username": "Unique login username (e.g. rahul.sharma)",
    "pages.studentBulkImport.csvGuide": "CSV Format Guide",
    "pages.studentBulkImport.processingRow": "Processing row {{current}} of {{total}} — {{name}}",
    "pages.studentBulkImport.validation.dobFormat": "dob must be {{format}} or YYYY-MM-DD",
    "pages.studentBulkImport.validation.dobInvalid": "dob is not a valid date",
    "pages.studentBulkImport.validation.emailInvalid": "email \"{{value}}\" is not valid",
    "pages.studentBulkImport.validation.genderInvalid": "gender \"{{value}}\" is invalid — must be MALE, FEMALE, or OTHER",
    "pages.studentBulkImport.validation.genderRequired": "gender is required (MALE / FEMALE / OTHER)",
    "pages.studentBulkImport.validation.invalidName": "{{field}} must be a valid name (letters, spaces, hyphens, apostrophes; accents allowed)",
    "pages.studentBulkImport.validation.phoneInvalid": "phoneNumber is not valid",
    "pages.studentBulkImport.validation.required": "{{field}} is required",
    "pages.studentDashboard.partialLoad": "Some dashboard data could not be loaded. Figures may be incomplete — refresh to try again.",
    "pages.userDetails.genderFemale": "Female",
    "pages.userDetails.genderMale": "Male",
    "pages.userDetails.genderOther": "Other",
    "pages.wallet.methodsLoadFailed": "Payment methods could not be loaded. Mode list may be incomplete.",
    "pages.wallet.unsupportedGateway": "Unsupported payment gateway response.",
    "pages.walletTopup.noManagedStudents": "No students in your managed branches yet. Add or enroll students first.",
    "parent.childrenLoadFailed": "Could not load linked students",
    "parent.childrenLoadFailedHint": "This is not the same as having no children. Refresh to try again.",
    "phone.digitsRequired": "Phone number must contain digits.",
    "phone.required": "Phone number is required.",
    "playing.academyStudents": "Academy students",
    "playing.assignSelectedPack": "Assign selected",
    "playing.assignToStudent": "Assign to",
    "playing.backToHub": "Back to hub",
    "playing.checkIn": "Check in",
    "playing.checkInFailed": "Could not update check-in.",
    "playing.checkedIn": "In",
    "playing.checkedInCount": "{{checked}}/{{total}} checked in",
    "playing.coachDebriefBoards": "Coach debrief — all boards",
    "playing.coachDesk": "Desk",
    "playing.coachRosterPicker": "Student on roster",
    "playing.coachRosterPickerMe": "My own games",
    "playing.confirmMoveAction": "Play move",
    "playing.copyStandings": "Copy standings",
    "playing.copyStudyPgn": "Copy annotated PGN",
    "playing.copyTeachingLink": "Copy teaching link",
    "playing.createAndOpen": "Create & open",
    "playing.createBan": "Ban player",
    "playing.createDraft": "Save draft",
    "playing.dismissPack": "Dismiss pack",
    "playing.draftFromMistakes": "Draft pack from game",
    "playing.draws": "Draws",
    "playing.fairnessTeachingHint": "{{n}} moves flagged (highest: {{level}}). Use for teaching — open fair-play if needed.",
    "playing.friendlyRematch": "Friendly rematch",
    "playing.friendlyRematchHint": "Outside the event · casual (unrated)",
    "playing.gameType.VS_COMPUTER": "vs Computer",
    "playing.increment": "Increment (sec)",
    "playing.liftBan": "Lift ban",
    "playing.livePeekLoadFailed": "Could not load live games right now.",
    "playing.loadRecentGame": "Load a recent game",
    "playing.loadRecentGamePlaceholder": "Choose a finished game…",
    "playing.losses": "Losses",
    "playing.matchmakingPausedShort": "Matchmaking paused — retry ban check",
    "playing.material": "Material",
    "playing.mistakeCount": "{{n}} mistakes",
    "playing.noRecentGamesToLoad": "No finished games to load yet. Paste a PGN or set a FEN below.",
    "playing.nudgeSent": "Reminder sent.",
    "playing.openCoachBoard": "Open on coach board",
    "playing.openFairPlay": "Open fair-play review",
    "playing.openForRegistration": "Open for registration",
    "playing.openRegistrationNow": "Open registration now (otherwise save as draft)",
    "playing.parentChallengeBlockedHint": "Parents can play vs the computer and watch their kids — human challenges are for players.",
    "playing.parentChallengeBlockedTitle": "Challenges are for players",
    "playing.parentChallengeHint": "Challenges are sent from your child’s account, not yours.",
    "playing.parentChallengeToastHint": "Parents don’t play human games — decline this invite, or play vs the computer from the hub.",
    "playing.pgn.clubGame": "Club game",
    "playing.pickTeam": "Pick a team",
    "playing.playersCount": "{{n}} players",
    "playing.privateGame": "Private",
    "playing.privateLinkHint": "This game is private — the copied link only works for the two players (and staff).",
    "playing.profile": "Profile",
    "playing.quality.best": "Best",
    "playing.quality.blunder": "Blunder",
    "playing.quality.brilliant": "Brilliant",
    "playing.quality.good": "Good",
    "playing.quality.inaccuracy": "Inaccuracy",
    "playing.quality.mistake": "Mistake",
    "playing.recentGamesLoadFailed": "Could not load recent games for the picker.",
    "playing.rematchNightHint": "Friendly (unrated) challenges outside the event",
    "playing.rematchNightOpponents": "Rematch night opponents",
    "playing.removePlayer": "Remove",
    "playing.removePlayerFailed": "Could not remove player.",
    "playing.reviewReadyStrip": "Review ready",
    "playing.saveDue": "Save due",
    "playing.saveFailed": "Could not save.",
    "playing.scrubToMistake": "Scrub to a mistake with a best move to save one ply.",
    "playing.selectStudent": "Select student…",
    "playing.solved": "Solved",
    "playing.speed.BLITZ": "Blitz",
    "playing.speed.BULLET": "Bullet",
    "playing.speed.CLASSICAL": "Classical",
    "playing.speed.CORRESPONDENCE": "Correspondence",
    "playing.speed.RAPID": "Rapid",
    "playing.startingNow": "Starting now",
    "playing.startsAt": "Starts at",
    "playing.startsIn": "Starts in {{when}}",
    "playing.stockfish.disabled": "Chess engine analysis is disabled on this server.",
    "playing.stockfish.notStarted": "Chess engine is not ready yet.",
    "playing.stockfish.unavailable": "Chess engine analysis is unavailable right now.",
    "playing.studyMistakes": "Study mistakes",
    "playing.studyOnCoachBoard": "Study",
    "playing.studyPgnCopied": "Annotated PGN copied",
    "playing.studySource": "Study source",
    "playing.suggestedBlunderer": "suggested",
    "playing.teachingLinkCopied": "Teaching link copied",
    "playing.teamBattleNoTeamsYet": "Teams are not set up yet — ask staff to add teams before joining.",
    "playing.undoCheckIn": "Undo",
    "playing.viewAllYourMoves": "View all your moves",
    "playing.waitingForOpponentDraw": "Waiting for opponent…",
    "playing.waitingForOpponentTakeback": "Waiting for opponent…",
    "playing.wins": "Wins",
    "playing.yourMoveMoreHint": "More games waiting on you",
    "playing.yourMoveStrip": "Your move",
    "playing.yourResult": "Your result",
    "playing.yourResultPlace": "#{{place}} · {{score}} pts",
    "reports.common.batchSession": "Batch",
    "reports.common.records": "{{count}} records",
    "reports.common.selectLevelFirst": "Select a level first to filter by batch",
    "reports.paymentsDue.statusOk": "OK",
    "reports.settingsLoadFailed": "Could not load report settings",
    "reports.settingsLoadFailedHint": "Report settings could not be refreshed. Availability below may be outdated.",
    "sessions.verifyAttendanceFailed": "Could not verify attendance. Complete is blocked until this succeeds — refresh and try again.",
    "settings.email.testCompleted": "Test completed. Delivery could not be fully verified — check spam/promotions.",
    "settings.email.testSmtpOnly": "SMTP accepted the message, but delivery was not fully verified.",
    "settings.email.testVerifiedSent": "Verified: message accepted by SMTP and found in Sent folder ({{seconds}}s). Ask the recipient to check inbox and spam.",
    "settings.holidays.emailPreview.roles.Other": "Other",
    "settings.notifications.channelStatusLoadFailed": "Could not refresh WhatsApp/email channel status. Toggle availability may be outdated — refresh the page.",
    "settings.notifications.loadFailed": "Could not load notification preferences.",
    "settings.whatsapp.messageTypes.ABSENCE_ALERT_STUDENT": "Absence alert (student)",
    "settings.whatsapp.messageTypes.CLASSROOM_STARTED_STUDENT": "Classroom started (student)",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_DEADLINE_REMINDER": "Correspondence deadline reminder",
    "settings.whatsapp.messageTypes.CORRESPONDENCE_YOUR_MOVE": "Correspondence — your move",
    "settings.whatsapp.messageTypes.FEE_REMINDER_STUDENT": "Fee reminder (student)",
    "settings.whatsapp.messageTypes.HOLIDAY_ANNOUNCEMENT": "Holiday announcement",
    "settings.whatsapp.messageTypes.LOW_BALANCE_ADMIN": "Low balance (admin)",
    "settings.whatsapp.messageTypes.LOW_BALANCE_STUDENT": "Low balance (student)",
    "settings.whatsapp.messageTypes.PENDING_SESSIONS_COACH": "Pending sessions (coach)",
    "settings.whatsapp.messageTypes.SESSION_CANCELLED_STUDENT": "Session cancelled (student)",
    "settings.whatsapp.messageTypes.SESSION_REMINDER_STUDENT": "Session reminder (student)",
    "wallet.txnReasons.unknown": "{{reason}}",
    "walletStaff.credit": "Credit",
    "walletStaff.debit": "Debit"
  }
};
